import type { I18nTranslations } from './i18n-en';

const i18n_es: I18nTranslations = {
  close_btn: 'Cerrar',
  search_placeholder: 'Buscar',
  loading: 'Cargando',

  label_inactive: 'Inactivo',
  label_invalid: 'Inválido',

  active_devices: ' {{devices_len}} Dispositivos activos',
  change_language: 'Cambiar idioma',
  language_changed_message: 'Idioma cambiado',

  error_select_device_message: 'Seleccione el dispositivo primero',
  select_device: 'Seleccione el dispositivo',
  select_company_menu_message: 'Seleccione empresa para ver la lista de dispositivos',
  select_company_required_header: 'Seleccione una empresa para continuar',
  select_company_required_from: 'Desde aquí: ',
  select_company_required_accounts_page_link: 'Página de Cuentas',

  error_forbidden_operation_not_allowed: 'No permitido',

  second: 'segundo',
  seconds: 'segundos',
  second_one: 'segundo',
  second_other: 'segundos',
  minute: 'minuto',
  minutes: 'minutos',
  minute_one: 'minuto',
  minute_other: 'minutos',
  hour: 'hora',
  hours: 'horas',
  hour_one: 'hora',
  hour_other: 'horas',
  day: 'día',
  day_one: 'día',
  day_other: 'días',
  start_date: 'Fecha Inicial',
  end_date: 'Fecha Final',
  from_date: 'Desde',
  to_date: 'Hasta',
  avg_from_date: 'Promedio desde la fecha',
  avg_to_date: 'Promedio hasta la fecha',
  period: 'Período',
  description: 'Descripción',
  date: 'Fecha',
  number: 'Serie',
  apply: 'Aplicar',
  update: 'Actualizar',
  create: 'Crear',
  delete: 'Eliminar',
  export: 'Exportar',
  rssi: 'RSSI',
  ber: 'BER',
  reading: 'Lectura',
  model: 'Modelo',
  email_address: 'Correo electrónico',
  password: 'Contraseña',
  confirm_password: 'Confirmar Contraseña',
  sign_in: 'Registrarse',
  graph: 'Gráfico',
  no_data: 'Sin datos',
  every: 'Cada',
  for_company: 'Para la compañia',
  flow: 'Caudal',
  no_data_found: 'Datos no encontrados.',
  percent: 'Porcentaje',
  device_number_devicenum: 'Serie del Dispositivo: {{device_number}}',
  device_number: 'Serie del Dispositivo',
  device_name: 'Nombre del dispositivo',
  successfully_saved: 'Exitosamente guardado',
  error_occured: 'An error occureOcurrió un errord',
  none: 'Ninguno',
  off: 'Apagado',
  no_unit: 'Sin unidad de medida',
  record_period: 'Período de Registro',
  replacement_number: 'Número de Reemplazor',
  replaced_by: 'Reemplazado por',

  createdOn: 'Creado el',
  createdBy: 'Creado por',

  hardware_version: 'Versión del Hardware',
  software_version: 'Versión del Software',
  transmission_period: 'Periodo de Transmisión',

  show_average: 'Mostrar promedio',
  show_readings: 'Mostrar lecturas',

  yes: 'Si',
  no: 'No',
  capital_yes: 'SI',
  capital_no: 'NO',

  sensor: 'Sensor',

  all_sensors: 'Todos los sensores',

  select_all: 'Seleccionar todo',
  deselect_all: 'Deseleccionar',

  function_last: 'Last',
  function_first: 'First',
  function_avg: 'Average',
  function_min: 'Min',
  function_max: 'Max',
  function_median: 'Median',
  function_count: 'Count',
  function_last_flow: 'Last Flow',
  function_first_flow: 'First Flow',
  function_avg_flow: 'Average Flow',
  function_max_flow: 'Max Flow',
  function_min_flow: 'Min Flow',
  function_median_flow: 'Median Flow',

  page_title_header_number_with_name_absent: '{{title}} - {{device_number}}',
  page_title_header_number_with_name_present: '{{title}} - {{device_name}} ({{device_number}})',

  not_set: 'No establecido',

  // Sensor Types
  generic_analog_sensor: 'Sensor analógico genérico',
  generic_virtual_sensor: 'Sensor virtual genérico',
  generic_digital_sensor: 'Sensor Digital Genérico',
  modbus_generic_analog_sensor: 'Sensor Analógico Genérico Modbus',
  modbus_generic_digital_sensor: 'Sensor Digital Genérico Modbus',
  pressure_sensor: 'Sensor de presión',
  temperature_sensor: 'Sensor de temperatura',
  humidity_sensor: 'Sensor de humedad',
  level_sensor: 'Sensor de nivel',
  weight_meter: 'Medidor de peso',
  weight_sensor: 'Sensor de peso',
  load_cells: 'Celdas de carga',
  wind_direction_sensor: 'Sensor de dirección del viento',
  barometric_pressure_sensor: 'Sensor de presión barométrica',
  soil_moisture_sensor: 'Sensor de humedad del suelo',
  dew_point_sensor: 'Sensor de punto de rocío',
  soil_temperature_sensor: 'Sensor de temperatura del suelo',
  soil_potential_sensor: 'Sensor de potencial del suelo',
  particulate_matter_sensor: 'Sensor de material particulado',
  leaf_wetness_sensor: 'Sensor de humedad de hojas',
  gnss_sensor: 'Sensor GNSS',
  water_meter: 'Medidor de agua',
  power_meter: 'Medidor de energía',
  gas_flow_meter: 'Medidor de flujo de gas',
  rain_sensor: 'Sensor de lluvia',
  wind_speed_sensor: 'Sensor de velocidad del viento',
  heat_meter: 'Medidor de calor',
  geiger_mueller_counter: 'Contador Geiger-Mueller',
  on_off_sensor: 'Sensor Encendido/Apagado',
  on_off_input_sensor: 'Sensor de Entrada Encendido/Apagado',
  on_off_output_sensor: 'Sensor de Salida Encendido/Apagado',
  on_off_auto_output_sensor: 'Sensor de Salida Encendido/Apagado/Automático',
  tasmota_relay_sensor: 'Sensor de Relé Tasmota',
  modbus_generic_on_off_input_sensor: 'Sensor de Entrada Encendido/Apagado Genérico Modbus',
  modbus_generic_on_off_output_sensor: 'Sensor de Salida Encendido/Apagado Genérico Modbus',
  co_sensor: 'Sensor de CO',
  no2_sensor: 'Sensor de NO2',
  so2_sensor: 'Sensor de SO2',

  // Port Types
  digital_input_port: 'Puerto de Entrada Digital',
  pulse_input_port: 'Puerto de Entrada de Pulso',
  pulse_s0_input_port: 'Puerto de Entrada de Pulso S0',
  analog_input_port: 'Puerto de Entrada Analógica',
  '4_20_mA_input_port': 'Puerto de Entrada 4-20mA',
  '0_5_V_input_port': 'Puerto de Entrada 0-5V',
  on_off_input_port: 'Puerto de Entrada On/Off',
  on_off_output_port: 'Puerto de Salida On/Off',
  generic_modbus_on_off_input_port: 'Puerto de Entrada On/Off Genérico Modbus',
  generic_modbus_on_off_output_port: 'Puerto de Salida On/Off Genérico Modbus',

  // duration
  duration_years_one: '{{count}} año',
  duration_years_other: '{{count}} años',
  duration_months_one: '{{count}} mes',
  duration_months_other: '{{count}} meses',
  duration_months_abbr: 'mes.',
  duration_days_one: '{{count}} día',
  duration_days_other: '{{count}} días',
  duration_hours_one: '{{count}} hora',
  duration_hours_other: '{{count}} horas',
  duration_minutes_one: '{{count}} minuto',
  duration_minutes_other: '{{count}} minutos',
  duration_seconds_one: '{{count}} segundo',
  duration_seconds_other: '{{count}} segundos',

  years: 'Años',
  months: 'Meses',
  days: 'Días',

  /*
   * |===============|
   * | Period Picker |
   * |===============|
   */
  period_date_range: 'Rango de fechas',
  period_custom: 'Personalizado',
  period_today: 'Hoy',
  period_week: 'Semana',
  period_month: 'Mes',
  period_yesterday: 'Ayer',
  period_last_week: 'La semana pasada',
  period_last_month: 'El mes pasado',
  period_last_1_hours: 'Ultima hora',
  period_last_2_hours: 'últimas 2 horas',
  period_last_4_hours: 'últimas 4 horas',
  period_last_24_hours: 'últimas 24 horas',
  period_last_48_hours: 'últimas 48 horas',

  /*
   * |=====================|
   * | Hook Error Messages |
   * |=====================|
   */
  error_cannot_fetch_device: 'No se pudo obtener el dispositivo.',
  error_cannot_fetch_device_config: 'No se pudo obtener la configuración del dispositivo.',
  error_cannot_fetch_ports_config: 'No se pudo recuperar la configuración de los puertos.',
  error_cannot_fetch_flow_stats: 'No se pudieron obtener las estadísticas de caudal.',
  error_cannot_fetch_time_stats: 'No se pudieron obtener las estadísticas de tiempo.',
  error_cannot_fetch_general_stats: 'No se pudieron obtener las estadísticas generales.',
  error_cannot_fetch_qflow_stats: 'No se pudieron obtener las estadísticas de qflow.',

  signup_company_name: 'Nombre de Empresa',

  sign_up_form_first_name: 'Nombre',
  sign_up_form_last_name: 'Apellido',
  sign_up_form_email: 'Correo electrónico',
  sign_up_form_password: 'Contraseña',
  sign_up_form_confirm_password: 'Confirmar Contraseña',
  sign_up_form_company_name: 'Nombre de Empresa',

  button_save: 'Salvar',
  button_apply: 'Aplicar',
  button_update: 'Actualizar',
  button_create: 'Crear',
  button_delete: 'Eliminar',
  button_continue: 'Continuar',
  button_back: 'Atrás',
  dashboard_tour_back: 'Atrás',
  dashboard_tour_next: 'Siguiente',
  dashboard_tour_finish: 'Finalizar',
  dashboard_tour_close: 'Cerrar',
  dashboard_tour_open: 'Abrir el diálogo',
  dashboard_tour_skip: 'Omitir',
  dashboard_tour_next_with_progress: 'Siguiente ({current} de {total})',
  capital_add_btn: 'AGREGAR',
  capital_create_btn: 'CREAR',
  capital_update_btn: 'ACTUALIZAR',
  capital_remove_btn: 'REMOVER',
  capital_cancel_btn: 'CANCELAR',

  role_roles: 'Roles',
  role_user: 'Usuario',
  role_public: 'Público',
  role_admin: 'Administrador',
  role_billing: 'Facturación',
  role_super_admin: 'Super-Administrador',
  role_restricted: 'Restringido',

  device_counters_cumulative_graph_graph: 'Gráfico, serie del dispositivo: {{device_number}}',
  device_counters_cumulative_graph_must_have_analog_sensor:
    'Debe tener un sensor analógico habilitado.',

  sensor_statistics_min: 'Mín: {{min}}',
  sensor_statistics_max: 'Máx: {{max}}',
  sensor_statistics_avg: 'Promedio: {{avrg}}',
  sensor_statistics_total: 'Total: {{total}}',

  chart_statistics_min: 'Mín:',
  chart_statistics_max: 'Máx:',
  chart_statistics_avg: 'Promedio:',
  chart_statistics_total: 'Total:',

  menu_main: 'Principal',
  menu_device: 'Dispositivo',

  submenu_devices: 'Dispositivos',
  submenu_account: 'Cuenta',
  submenu_device_reports: 'Informes de dispositivos',
  submenu_settings: 'Ajustes',

  link_selected_device: 'Dispositivo Seleccionado',
  link_device_nodes: 'Nodos de Dispositivos',
  link_devices: 'Lista de dispositivos',
  link_accounts: 'Cuentas',
  link_utility_rate: 'Tarifa',
  link_link_device: 'Vincular Dispositivo',
  link_create_user: 'Crear Usuario',
  link_icons: 'Íconos',
  link_licenses: 'Licencias',
  link_accounts_manager: 'Cuentas de Administración',
  link_transmissions: 'Transmisiones',
  link_map: 'Mapa',
  link_inventory: 'Inventario',
  link_devices_manager: 'Administrador de Dispositivos',
  link_battery: 'Batería',
  device_groups: 'Grupos de Dispositivos',
  link_signal: 'Señal',
  link_alarms: 'Alarmas',
  link_value_ranges: 'Eventos de rango de valor',
  link_device_account_lookup: 'Búsqueda de dispositivos',
  link_show_users: 'Usuarios',
  link_dashboard: 'Panel de Control',
  link_dashboard_2: 'Panel de Control 2',
  link_reports: 'Reportes',
  link_scheduled_reports: 'Reportes Programados',
  link_billing_report: 'Informe de facturación',

  link_all_devices: 'Todos los Dispositivos',
  link_readings: 'Lecturas',
  link_sensors_data: 'Datos de Sensores',
  link_flow: 'Caudal',
  link_graph: 'Gráfico',
  link_new_graph: 'Gráfico Instantáneo',
  link_pump_control: 'Control de la Bomba',
  link_relay_control: 'Control del Relay',
  link_alarm_config: 'Configurar Alarmas',
  link_statistics: 'Estadísticas',
  link_customer: 'Datos del Cliente',
  link_meter: 'Datos del Medidor',
  link_config: 'Sincronización de configuración',
  link_initial_config: 'Configurar Comunicación (antigua)',
  link_sensor_config: 'Configurar Sensor (antigua)',
  link_sensors_and_network_config: 'Configuración de parámetros',
  link_export: 'Exportar Lecturas',
  link_customer_billing_report: 'Informe de facturación de clientes',
  link_flow_generator: 'Generador de Caudal',
  link_commands: 'Enviar Comandos',
  link_copy_config: 'Copiar configuración',
  switch_to_new_menu_label: 'Usar nuevo menú',
  switch_to_old_menu_label: 'Usar menú antiguo',

  link_profile: 'Perfil',
  link_language: 'Idioma',
  link_sign_out: 'Desconectar',

  chip_early_access: 'Acceso Rápido',

  pulse_sensor_1: 'Sensor de Pulso 1',
  pulse_sensor_2: 'Sensor de Pulso 2',
  analog_sensor_1: 'Sensor Análogo 1',
  analog_sensor_2: 'Sensor Análogo 2',
  analog_sensor_3: 'Sensor Análogo 3',
  analog_sensor_4: 'Sensor Análogo 4',
  analog_sensor_5: 'Sensor 1',
  analog_sensor_6: 'Sensor 2',
  analog_sensor_7: 'Sensor 3',
  analog_sensor_8: 'Sensor 4',
  on_off_sensor_1: 'Sensor de encendido/apagado 1',
  on_off_sensor_2: 'Sensor de encendido/apagado 2',
  on_off_sensor_3: 'Relé de encendido/apagado 1',
  on_off_sensor_4: 'Relé de encendido/apagado 2',

  device_icon: 'Icono de dispositivo',
  sensor_icon: 'Icono de sensor',
  icon_no_icon: 'Sin icono',
  icon_barometer: 'Barómetro',
  icon_door_closed: 'Puerta cerrada',
  icon_door_open: 'Puerta abierta',
  icon_electricity: 'Electricidad',
  icon_energy_meter: 'Medidor de energía',
  icon_gas_flow_meter: 'Medidor de flujo de gas',
  icon_gas: 'Gas',
  icon_generic_particle_meter: 'Medidor de partículas genérico',
  icon_generic: 'Genérico',
  icon_heat_meter: 'Medidor de calor',
  icon_humidity: 'Humedad',
  icon_leaf_moisture: 'Humedad de la hoja',
  icon_level_metering: 'Medición de nivel',
  icon_pivot: 'Pivote',
  icon_pressure: 'Presión',
  icon_radiation: 'Radiación',
  icon_rain: 'Lluvia',
  icon_soil_moisture: 'La humedad del suelo',
  icon_temperature: 'La temperatura',
  icon_water_meter: 'Medidor de agua',
  icon_water: 'Agua',
  icon_wind_direction: 'Dirección del viento',
  icon_wind_speed: 'Velocidad del viento',
  icon_pump: 'Bomba',
  icon_apartment: 'Edificio de Apartamentos',
  icon_base_station: 'Estación Base',
  icon_clinic: 'Clínica',
  icon_hospital: 'Hospital',
  icon_house: 'Casa',
  icon_mayor_office: 'Edificio de la Oficina del Alcalde',
  icon_police_station: 'Estación de Policía',
  icon_public_restroom: 'Instalación de Baño Público',
  icon_stadium: 'Estadio',
  icon_gas_station: 'Estación de servicio',
  icon_controller: 'Controlador',

  device_icon_new_portal: 'Ícono (nuevo portal)',
  device_icon_old_portal: 'Ícono (antiguo portal)',

  very_low_level_alarm: 'Alarma de nivel muy bajo',
  low_level_alarm: 'Alarma de nivel bajo',
  high_level_alarm: 'Alarma de nivel alto',
  very_high_level_alarm: 'Alarma de nivel muy alto',

  sensor_conversion_formula: 'Fórmula de conversión del sensor',
  delete_old_counters: 'Borrar informes antiguos',
  device_config_select_record_period: 'Seleccionar período de registro',
  device_config_select_transmission_period: 'Seleccionar período de transmisión',

  devices_table_number: 'Número',
  devices_table_name: 'Nombre',
  devices_table_device_number: 'Número de dispositivo',
  devices_table_device_name: 'Nombre del dispositivo',
  devices_table_business_partner: 'Socio comercial',
  devices_table_quarter: 'Trimestre',
  devices_table_address: 'Dirección',
  devices_table_error: 'No se han podido cargar los dispositivos',
  devices_table_no_devices_found: 'No se encontraron dispositivos',
  devices_table_description: 'Descripción',
  devices_column_header_search: 'Buscar...',

  alarm_config_header: 'Configurar alarmas',
  alarm_config_notification_email: 'Correos electrónicos de notificación',
  alarm_config_notification_email_place_holder:
    'Lista de correos electrónicos (separados por comas)',
  alarm_config_missed_transmission_email:
    'Direcciones de correo electrónico para transmisiones perdidas',
  alarm_config_missed_transmission_email_place_holder:
    'Lista de correo electrónico de transmisiones perdidas (separadas por comas)',
  alarm_config_high_consumption_threshold:
    'Umbral de consumo alto para el período de transmisión {{transmission_every}} {{transmission_period}} [{{units}}]',
  alarm_config_low_flow_alarm_threshold: 'Umbral de Alarma de Flujo Bajo [{{units}}]',
  alarm_config_high_flow_alarm_threshold: 'Umbral de Alarma de Flujo Alto [{{units}}]',
  alarm_config_non_zero_consumption_time_range: 'Intervalo de tiempo de consumo distinto de cero',
  alarm_config_high_low_flow_time_range: 'Intervalo de tiempo para caudal alto/bajo',
  alarm_config_start_time: 'Hora de inicio',
  alarm_config_end_time: 'Hora de término',
  alarm_config_flow_calc_time_base: 'Base de tiempo para cálculo de caudal',
  alarm_config_saved_msg: 'Configuración de Alarma Guardada.',
  alarm_config_email_validation_error:
    'Por favor, ingrese direcciones de correo electrónico válidas, separadas por una sola coma y sin espacio, con un máximo de 255 caracteres.',

  alarm_config_non_zero_consumption_time_range_error:
    'Debe tener una hora de inicio y una hora de fin',
  alarm_config_low_flow_severity: 'Gravedad de flujo bajo',
  alarm_config_high_flow_severity: 'Gravedad de flujo alto',
  alarm_config_high_consumption_severity: 'Gravedad de alto consumo',
  alarm_config_all_zero_severity: 'Gravedad de consumo cero',
  alarm_config_non_zero_consumption_severity: 'Gravedad de consumo no cero',
  alarm_config_on_off_severity: 'Gravedad de encendido/apagado',

  alarms_title: 'Alarmas',
  alarms_title_with_dev_num: 'Alarmas, serie del dispositivo: {{device_number}}',
  alarms_type: 'Tipo de Alarma',
  alarms_active_status: 'Actividad',
  alarms_active_dropdown_label: 'Activo',
  alarms_inactive_dropdown_label: 'Inactivo',

  device_battery_title: 'Nivel de batería',
  device_battery_voltage: 'Voltaje, mV',
  device_battery_level: 'Nivel, %',

  device_signal_title: 'Intensidad de señal',

  device_counters_graph_header: 'Gráfico de consumo',

  device_instant_graph_header: 'Gráfico Instantáneo',

  devices_signal_title: 'Señal de dispositivos',
  devices_signal_level: 'Nivel de señal',
  devices_signal_level_percent: 'Nivel, %',

  devices_battery_title: 'Nivel de baterías',
  devices_battery_level: 'Nivel de batería, %',
  devices_battery_voltage: 'Voltaje, mV',

  reports_export_title: 'Exportación de Lecturas',

  device_counter_export_title:
    'Exportar contadores de dispositivos, serie del dispositivo: {{device_number}}',

  device_config_record_and_transmission_period: 'Períodos de registro y transmisión',
  device_config_record_period: 'Período de Registro',
  device_config_transmission_period: 'Periodo de Transmisión',
  device_config_start_setup: 'Iniciar Configuración',
  device_config_setup_message:
    'Configuración Guardada. Ahora pase un imán por el costado del dispositivo.',
  device_config_header: 'Configurar dispositivo',
  device_config_config_date: 'Fecha de configuración: {{date}}',
  device_config_config_status: 'Estado',
  device_config_config_status_configured: 'Sincronizado',
  device_config_config_status_not_configured: 'No sincronizado',
  device_config_time_zone: 'Zona horaria',
  device_config_pulse_per: '{{x}} por pulso',
  device_config_sensor_type: 'Tipo de Sensor',
  device_config_meter_type: 'Tipo de Medidor',
  device_config_select_time_zone: 'Selecciona la zona horaria',
  device_config_missed_transmission_alarm_severity: 'Gravedad de la alarma de transmisión perdida',
  device_config_pulse_coef_not_changed_message:
    'Advertencia: El "Coeficiente de pulso" personalizado permanece sin cambios ante los cambios en "Lectura Inicial"',
  device_config_does_not_support_this_model:
    'Este modelo de dispositivo no es compatible en esta página.',

  device_digits_fraction: 'Decimales',
  device_digits_digits: 'Enteros',
  device_digits_initial_reading: 'Lectura Inicial',
  device_digits_alert_too_many_total_digits: 'El número total de dígitos debe ser <= 9',
  device_digits_alert_too_small_total_digits: 'El número total de dígitos debe ser >= 4',
  device_digits_alert_too_many_total_fraction:
    'El número de dígitos después del punto decimal debe ser <= 3 y el número total de dígitos debe ser <= 9',
  device_digits_alert_too_small_total_fraction:
    'El número de dígitos después del punto decimal debe ser >= 0 y el número total de dígitos debe ser >= 4',

  device_transmissions_at: 'Transmisiones del dispositivo al {{query_date}}',
  device_transmissions_last_transmission_short: 'Última transmisión',
  device_transmissions_next_transmissions_short: 'Próxima transmisión',
  device_transmissions_days: 'Días',
  device_transmissions_transmissions_short: 'Transm',
  device_transmissions_count: 'Conteo',
  device_transmissions_fail: 'Fallar',
  device_transmissions_customer: 'Cliente',
  device_transmissions_address: 'Dirección',
  device_transmissions_ok: 'OK',

  link_device_link_device_to_my_account: 'Vincular dispositivo a mi cuenta',
  link_device_device_number: 'Número del Dispositivo',
  link_device_unlink_device: 'Desvincular Dispositivo',
  link_device_with_device_number: `Vincular dispositivo: {{device_number}}`,
  unlink_device_with_device_number: `Desvincular dispositivo: {{device_number}}`,
  link_device_devices_counts:
    'Dispositivos vinculados: {{linked_devices_count}} / {{allowed_devices_count}}',
  link_device_success_message: 'Dispositivo asociado con éxito',
  unlink_device_success_message: 'Dispositivo desvinculado exitosamente de: ',
  link_device_enter_device_number_error: 'Ingrese un número de dispositivo',
  link_device_select_company_error: 'Seleccione una empresa',
  link_device_default_error: 'Hubo un problema al vincular/desvincular el dispositivo',
  link_device_company_not_found_error: 'Empresa no encontrada',
  link_device_device_not_found_error: 'Dispositivo {{device_number}} no encontrado',
  link_device_device_not_linked_error: 'Dispositivo {{device_number}} no está vinculado',
  link_device_device_already_linked_error: 'Dispositivo {{device_number}} ya está vinculado',
  link_device_device_limit_reached_error: 'Límite de dispositivos alcanzado',
  link_device_operation_not_allowed_error: 'Operación no permitida',
  link_device_unlink_devices_for_sub_accounts: 'Desvincular dispositivo de todas las subcuentas',
  link_device_unlink_devices_for_sub_accounts_tooltip:
    'Si está marcado, el dispositivo se desvinculará de la cuenta seleccionada y de todas las subcuentas. Si no está marcado, el dispositivo se desvinculará solo de la cuenta seleccionada.',
  link_device_lookup_title: 'Búsqueda de dispositivo',
  link_device_lookup_subheader:
    'Haga clic en una fila de esta tabla para completar automáticamente el número del dispositivo en el formulario de vinculación.',
  link_device_lookup_filter_number: 'Número',
  link_device_lookup_filter_name: 'Nombre',
  link_device_lookup_device_name: 'Nombre del dispositivo',
  link_device_lookup_device_number: 'Número del dispositivo',
  link_device_lookup_no_devices_found: 'No se encontraron dispositivos',

  device_search_device_number: 'Número del Dispositivo',
  device_search_kicker: 'Contexto de empresa',
  device_search_title: 'Búsqueda de empresa por dispositivo',
  device_search_subtitle:
    'Busca por número de dispositivo y selecciona la empresa que debe permanecer activa en management.',
  device_search_device_number_placeholder: 'Introduzca el número del dispositivo',
  device_search_length_hint: 'La búsqueda se inicia automáticamente cuando deja de escribir.',
  device_search_clear: 'Limpiar',
  device_search_selected_company: 'Empresa seleccionada',
  device_search_selected_company_hint:
    'Haga clic de nuevo en la misma fila para borrar la selección actual de empresa.',
  device_search_error: 'No se pudieron cargar las empresas para este número de dispositivo.',
  device_search_no_matches: 'No se encontraron empresas para este número de dispositivo.',
  device_search_results_title: 'Empresas coincidentes',
  device_search_results_ready:
    'Seleccione una fila para actualizar el contexto activo de la empresa.',
  device_search_results_waiting: 'Introduzca un número de dispositivo para iniciar la búsqueda.',
  device_search_empty_prompt:
    'Introduzca un número de dispositivo para buscar empresas coincidentes.',
  device_search_empty_prompt_subtitle: 'Los resultados aparecerán aquí cuando deje de escribir.',
  device_search_domain: 'Dominio',

  device_manager_create_or_delete_device: 'Crear o eliminar dispositivo: {{device_number}}',
  device_manager_device_number: 'Número del Dispositivo',
  device_manager_device_model: 'Modelo de Dispositivo',
  device_manager_sw_version_validation:
    'El formato requerido es X.X.X o X.X.X- y X.X.X_ seguido de caracteres, donde X es un número',
  device_manager_hw_version_validation: 'El formato requerido es X.X.X donde X es un número',
  device_manager_software_version: 'Versión del Software',
  device_manager_hardware_version: 'Versión del Hardware',

  dashboard_alarms: 'Alarmas',
  dashboard_batteries: 'Baterías',
  dashboard_signal: 'Señal',
  dashboard_transmission: '{{alarm_type}} ({{alarm_count}})',
  dashboard_chart_battery_level: 'Nivel de bateria',
  dashboard_chart_signal_level: 'Nivel de señal',
  dashboard_chart_number_of_devices: 'Número de dispositivos',
  dashboard_select_company_header: 'Seleccione una cuenta para ver el tablero',
  dashboard_select_company_from: 'Desde aquí: ',
  dashboard_select_company_accounts_page_link: 'Cuentas',

  alarm_type_no_zero_consumption: 'Consumo Constante',
  alarm_type_high_consumption: 'Alto Consumo',
  alarm_type_high_flow: 'Alto Caudal',
  alarm_type_missed_transmission: 'Transmisión Fallida',
  alarm_type_low_flow: 'Bajo Caudal',
  alarm_type_all_zero_consumption: 'Consumo cero',
  alarm_type_device_removed: 'Dispositivo Eliminado',
  alarm_type_on_off_alarm: 'Alarma de encendido/apagado',
  alarm_type_low_level: 'Alarma de Nivel Bajo',
  alarm_type_high_level: 'Alarma de Nivel Alto',
  alarm_type_tamper: 'Intervención',
  alarm_type_oversized: 'Sobre-dimensionado',
  alarm_type_undersized: 'Sub-dimensionado',
  alarm_type_low_battery: 'Batería baja',
  alarm_type_blockage: 'Detenido',
  alarm_type_burst: 'Fuga Importante',
  alarm_type_reverse_flow: 'Caudal inverso',
  alarm_type_range_event: 'Evento de rango',
  alarm_type_very_low_level: 'Nivel muy bajo',
  alarm_type_very_high_level: 'Nivel muy alto',
  alarm_type_leakage: 'Fuga',
  alarm_type_low_temperature: 'Temperatura baja',
  alarm_type_no_consumption: 'Sin consumo',
  alarm_type_negative_flow: 'Caudal negativo',
  alarm_type_empty_spool: 'Tubería vacía',
  alarm_type_combination_of_alarms: 'Combinación de alarmas',
  alarm_type_standstill: 'Sin movimiento',
  alarm_type_reset_error: 'Error de reinicio',
  alarm_type_rf_error: 'Error RF',
  alarm_type_cs_error: 'Error CS',
  alarm_type_measuring_error: 'Error de medición',
  alarm_type_reset_event: 'Reinicio',
  alarm_type_magnetic_field: 'Campo magnético',
  alarm_type_sensor_fraud: 'Fraude en el sensor',

  device_counter_graph_min: 'Mín: {{min}}',
  device_counter_graph_max: 'Máx: {{max}}',
  device_counter_graph_avg: 'Promedio: {{avrg}}',
  device_counter_graph_total: 'Total: {{total}}',
  device_counter_graph_average: 'Promedio:',
  device_counter_graph_no_data: 'Sin datos',
  device_counter_graph_cant_calculate_flow_analog:
    '¡No se puede calcular el flujo para un sensor analógico!',
  device_counter_graph_must_have_digital_sensor: 'Debe tener un sensor digital habilitado.',

  customer_info_header: 'Información del Cliente',
  customer_info_business_partner_number: 'Cuenta',
  customer_info_contact_data: 'Dato de Contacto',
  customer_info_contract_number: 'Rol de Lectura',
  customer_info_name: 'Nombre del Cliente',
  customer_info_description: 'Descripción',
  customer_info_billing_group: 'Grupo de facturación',
  customer_info_municipality: 'Ciudad',
  customer_info_quarter: 'Región',
  customer_info_street: 'Calle',
  customer_info_block: 'Block',
  customer_info_entr: 'Departamento',
  customer_info_customer_type: 'Tipo de Cliente',
  customer_info_customer_type_commercial: 'Comercial',
  customer_info_customer_type_domestic: 'Doméstico',
  customer_info_customer_type_block_of_flats: 'Condominio',
  customer_info_customer_type_budget: 'Remarcador',

  meter_info_meter_info: 'Información del Medidor: {{device_number}}',
  meter_info_factory_number: 'Serie del Medidor',
  meter_info_brand: 'Marca',
  meter_info_enter_diameter: 'Introduzca el Diámetro',
  meter_info_mount_date: 'Fecha de Instalación',
  meter_info_meter_info_saved: 'Información del Medidor Guardada.',

  device_initial_config_header: 'Configuración Inicial del Dispositivo',
  device_initial_device_model: 'Modelo del Dispositivo',
  device_initial_config_address: 'Dirección',
  device_initial_config_port: 'Puerto',
  device_initial_config_resolve_address: 'Resolver dirección (usar DNS)',
  device_initial_config_simcard_provider: 'Proveedor de Tarjeta SIM',
  device_initial_config_simcard_number: 'Número de Tarjeta SIM',
  device_initial_config_bands: 'bandas',
  device_initial_config_OTAA_appkey: 'OTAA - appkey',
  device_initial_config_OTAA_deveui: 'OTAA - deveui',
  device_initial_config_OTAA_appeui: 'OTAA - appeui',
  device_initial_config_ABP_appskey: 'ABP - appskey',
  device_initial_config_ABP_nwkskey: 'ABP - nwkskey',
  device_initial_config_ABP_devaddr: 'ABP - devaddr',
  device_initial_config_ABP_deveui: 'ABP - deveui',
  device_initial_config_lora_app_mode: 'Modo de aplicación',
  device_initial_config_app_id: 'ID de la aplicación',
  device_initial_config_profile_id: 'ID de perfil',
  device_initial_config_platform_name: 'Nombre de la plataforma',
  device_initial_config_thingslog_lora_platform: 'Plataforma ThingsLog LoRa',
  device_receive_data_binary: 'Recibir datos binarios',
  device_send_data_binary: 'Enviar datos binarios',
  device_mqtt_config: 'MQTT configuración',
  device_mqtt_config_qos: 'Calidad de servicio',
  device_mqtt_config_username: 'Nombre de usuario',
  device_mqtt_config_password: 'Contraseña',
  device_mqtt_config_certificate: 'Certificado',
  device_initial_config_apn_username: 'Nombre de Usuario APN',
  device_initial_config_apn_password: 'Contraseña APN',
  device_initial_config_gprs_radio_mode: 'Modo de Radio GPRS',
  device_initial_config_grps_radio_mode_auto_option: 'Automático',
  device_initial_config_net_attached_delay: 'Retraso de transmisión',
  device_initial_config_preferred_network_type: 'Tipo de Red Preferido',
  device_initial_config_preferred_network_default_option: 'Por defecto',
  device_initial_config_mcc_mnc: 'MCC-MNC',
  device_initial_config_slave_devices: 'Dispositivos esclavos',
  device_initial_config_modbus_address: 'Dirección Modbus',
  device_initial_config_modbus_master_device: 'Número del dispositivo maestro',
  device_initial_config_trashcan_brand: 'Marca',
  device_initial_config_trashcan_model: 'Modelo',
  device_initial_config_trashcan_volume: 'Volumen',
  device_initial_config_trashcan_max_weight: 'Peso máximo',
  device_initial_config_trashcan_material: 'Material',
  device_initial_config_trashcan_color: 'Color',
  device_initial_config_trashcan_waste_type: 'Tipo de residuo',
  device_initial_config_trashcan_waste_type_plastic: 'Plástico',
  device_initial_config_trashcan_waste_type_bio: 'Bio',
  device_initial_config_trashcan_waste_type_paper: 'Papel',
  device_initial_config_trashcan_waste_type_glass: 'Vidrio',
  device_initial_config_trashcan_waste_type_metal: 'Metal',
  device_initial_config_trashcan_waste_type_mixed: 'Mixto',
  device_initial_config_trashcan_waste_type_other: 'Otro',
  device_initial_config_trashcan_pricing: 'Precio',
  device_initial_config_trashcan_pricing_free: 'Gratis',
  device_initial_config_trashcan_pricing_per_lift: 'Por recogida',
  device_initial_config_trashcan_pricing_per_kg: 'Por kilogramo',
  device_initial_config_trashcan_pricing_per_subscription: 'Por suscripción',
  device_initial_config_trashcan_placement: 'Ubicación',
  device_initial_config_trashcan_placement_on_the_street: 'En la calle',
  device_initial_config_trashcan_placement_inside: 'Interior',
  device_initial_config_trashcan_placement_backyard: 'Patio',
  device_initial_config_trashcan_customer_community_id: 'ID de comunidad de clientes',
  device_initial_config_trash_truck_brand: 'Marca',
  device_initial_config_trash_truck_plate_number: 'Número de placa',
  device_initial_config_trash_truck_model: 'Modelo',
  device_initial_config_find_encryption_key_by_device_number:
    'Encontrar clave de encriptación por número de dispositivo',

  sensor_config_header: 'Configuración de Sensor',
  sensor_config_name: 'Nombre',
  sensor_config_sensor_name: 'Nombre del Sensor',
  sensor_config_sensor_icon: 'Nombre icónico',
  sensor_config_description: 'Descripción',
  sensor_config_model: 'Modelo',
  sensor_config_serial_number: 'Número de Serie',
  sensor_config_manufacturer: 'Fabricante',
  sensor_config_diameter: 'Diámetro',
  sensor_config_price: 'Precio',
  sensor_config_currency: 'Moneda',
  sensor_config_supported_visualization_types: 'Tipos de visualización soportados',
  sensor_config_port_type: 'Tipo de Puerto',
  sensor_config_port_type_digital_input_port: 'Puerto de Entrada Digital',
  sensor_config_port_type_analog_input_port: 'Puerto de Entrada Analógica',
  sensor_config_port_type_pulse_s0_input_port: 'Puerto de Entrada de Pulso S0',
  sensor_config_port_type_pulse_input_port: 'Puerto de Entrada de Pulsos',
  sensor_config_port_type_on_off_input_port: 'Puerto de Entrada encendido/apagado',
  sensor_config_port_type_on_off_output_port: 'Puerto de Salida encendido/apagado',
  sensor_config_port_conversion_formula: 'Fórmula de Conversión de Puerto',
  sensor_config_formula: 'Fórmula',
  sensor_config_offset: 'Compensación',
  sensor_config_sensor_index_tooltip: 'índice de sensores: {{sensor_index}}',
  sensor_config_visible: 'Visibilidad',
  sensor_config_order_number: 'Número de pedido',
  sensor_config_visible_true: 'Visible',
  sensor_config_visible_false: 'Invisible',
  sensor_config_use_in_sensor_aggregation: 'Uso en agregación de sensores',
  sensor_config_use_in_sensor_aggregation_true: 'Usar',
  sensor_config_use_in_sensor_aggregation_false: 'No usar',
  sensor_config_value_labels: 'Etiquetas de valores',
  sensor_config_label_for_value_zero: 'Etiqueta para el valor "0"',
  sensor_config_label_for_value_one: 'Etiqueta para el valor "1"',
  sensor_config_inverted_read_state_value: 'Estado de lectura invertido',
  sensor_config_inverted_read_state_value_true: 'Invertido',
  sensor_config_inverted_read_state_value_false: 'No invertido',
  sensor_config_register_address: 'Dirección del registro',
  sensor_config_data_type: 'Tipo de datos',
  sensor_config_count: 'Cantidad',
  sensor_config_number_registers: 'Número de registros',
  sensor_config_particle_size: 'Tamaño de partícula',
  sensor_config_power: 'Potencia',
  sensor_config_measurement_type: 'Tipo de medición',
  sensor_config_measurement_group: 'Grupo de medición',
  tasmota_generic_digital_sensor: 'Sensor digital genérico Tasmota',
  tasmota_alarm_input_sensor: 'Sensor de entrada de alarma Tasmota',
  tasmota_generic_analog_sensor: 'Sensor analógico genérico Tasmota',

  device_counter_statistics_statistics_id: 'Estadísticas, id: {{device_number}}, {{description}}',
  device_counter_statistics_quarter: 'Localidad',
  device_counter_statistics_flow: 'Caudal',
  device_counter_statistics_hour: 'Hora',
  device_counter_statistics_quantity: 'Cantidad',
  device_counter_statistics_value: 'Valor',
  device_counter_statistics_digital_ports_must_be_present:
    'Debe tener una entrada de pulso conectada al sensor de un medidor de agua para ver esta tabla.',
  device_counter_statistics_name_must_have_initialized_value:
    'Los parámetros Q3, R y Diámetro son necesarios en la entrada de pulsos conectada al sensor del medidor de agua.',

  company_manager_title: 'Crear o borrar cuenta: {{company_name}}',
  company_manager_account_name: 'ID Cuenta',
  company_manager_solution: 'Тipo de proyecto',
  company_manager_solution_option_none: 'Sin asignar',
  company_manager_solution_option_agri: 'Agrario',
  company_manager_solution_option_air_quality: 'Aire limpio',
  company_manager_solution_option_street_lights: 'Alumbrado público',
  company_manager_solution_option_pump_station: 'Estación de bombeo',
  company_manager_solution_option_smart_waste: 'Residuos Inteligentes',
  company_manager_solution_option_level: 'Monitoreo de nivel',
  company_manager_solution_option_gas: 'Monitoreo de gas',
  company_manager_solution_option_pressure: 'Monitoreo de presión',
  company_manager_solution_option_smart_water: 'Agua Inteligente',
  company_manager_solution_option_environment_monitoring: 'Monitoreo del medio ambiente',
  company_manager_solution_option_energy: 'Monitoreo de energía',
  company_manager_license: 'Licencia',
  company_manager_account: 'Cuenta',
  company_manager_create_company: 'Crear empresa',
  company_manager_create_company_error: 'Hubo un problema al crear su empresa',
  company_manager_license_info_box:
    'El adjunto de licencia requiere una ID de cuenta válida. Verifique dos veces el valor de su ID de cuenta si desea incluirlo en el proceso de creación.',
  company_manager_valid_from: 'Válido desde',
  company_manager_valid_to: 'Válido hasta',
  company_manager_solution_type: 'Tipo de solución',
  company_manager_contact_id: 'ID de contacto',
  company_manager_account_id: 'ID de cuenta',
  company_manager_license_type: 'Tipo de Licencia',
  company_manager_timezone: 'Zona horaria',
  company_manager_country: 'País',
  company_manager_countries_error: 'No se pudieron cargar los países',
  company_manager_timezones_error: 'No se pudieron cargar las zonas horarias',
  company_manager_account_info: 'Información de la cuenta',
  company_manager_address: 'Dirección',
  company_manager_city: 'Ciudad',
  company_manager_municipality: 'Municipio',
  company_manager_area: 'Área',
  company_manager_zip_code: 'Código postal',
  company_manager_vat_number: 'Número de IVA',
  company_manager_account_ext_number: 'Número de cuenta externo',
  company_manager_account_ext_type: 'Tipo de cuenta externo',
  company_manager_account_ext_type_none: 'Ninguno',
  company_manager_account_ext_type_household: 'Hogar',
  company_manager_account_ext_type_business: 'Negocio',

  company_manager_license_per_device: 'Por dispositivo',
  company_manager_license_per_reading: 'Por informe',
  company_manager_license_per_sensor: 'Por sensor',
  company_manager_license_per_poc: 'Por Prueba de Concepto (POC)',
  company_manager_license_per_remote_node: 'Por Nodo Remoto',

  company_manager_creating_account: 'Creando cuenta: {{company_name}}',
  company_manager_deleting_account: 'Eliminando cuenta: {{company_name}}',
  company_manager_account_created: 'Cuenta creada correctamente',
  company_manager_account_deleted: 'Cuenta eliminada correctamente',

  company_manager_update_company: 'Actualizar cuenta',
  company_manager_delete_company: 'Eliminar cuenta',
  company_manager_actions: 'Acciones',
  company_manager_delete_modal_description:
    '¿Estás seguro de que quieres eliminar esta cuenta? La acción es irreversible.',
  company_manager_confirm_button: 'Confirmar',
  company_manager_cancel_button: 'Cancelar',
  company_manager_delete_company_error_message: 'Ocurrió un error al eliminar la cuenta',
  company_manager_update_btn: 'Actualizar',
  company_manager_child_company_warning_message: 'Creando una subcuenta de',
  company_manager_current_logged_in_company: 'la cuenta en la que estás actualmente conectado',
  company_manager_current_selected_company: 'la cuenta que has seleccionado actualmente',
  accounts_child_companies: 'Cuentas secundarias',
  accounts_contactRef: 'ID de contacto',
  accounts_externalNumber: 'Numero externo',
  accounts_accountRef: 'ID de cuenta',
  accounts_logo: 'Logo',
  accounts_info_unavailable: 'No hay informacion de la empresa para esta cuenta.',
  company_manager_accountRef_is_disabled_because_of_license_type:
    'El ID de cuenta está deshabilitado porque hay una licencia por POC',
  accounts_none: 'Ninguno',
  company_manager_update_company_success: 'Cuenta actualizada con éxito',
  company_manager_update_company_error: 'Ocurrió un error al actualizar la cuenta',
  company_manager_account_name_exists: 'Ya existe una cuenta con este nombre.',

  license_manager_title: 'Actualizar licencia: {{company_name}}',
  license_manager_license: 'Licencia',
  license_manager_license_updated: 'Licencia actualizada',

  companies_title: 'ID Compañía: {{company_number}}',
  companies_table_name: 'Nombre',
  companies_number_of_accounts: 'Numero de cuentas:',
  companies_search: 'Búsqueda',

  users_title: 'Usuarios',
  units_type: 'Tipo de Unidades',

  reports_export_format_type: 'Formato',

  login_form_forgot_password: '¿Se te olvidó tu contraseña?',

  pump_auto_every: 'Auto cada {{secs}} segundos',
  pump_svg_last_updated: 'Última Actualización: {{timestamp}}',
  pump_svg_power_supply: 'Fuente de Poder',
  pump_svg_water_level_controller: 'Controlador de Nivel de Agua',
  pump_svg_pump: 'Bomba',
  pump_svg_level_sensor: 'Sensor de Nivel',
  pump_svg_pump_on_sensor: 'Sensor Bomba Encendida',
  pump_svg_pump_off_sensor: 'Sensor Bomba Apagada',
  pump_svg_dry_run_sensor: 'Sensor Funcionamiento en Seco',

  device_groups_error_please_select_company: 'Seleccione una empresa.',

  device_groups_btn_add: 'Agregar',
  device_groups_btn_edit: 'Editar',
  device_groups_btn_delete: 'Borrar',
  device_groups_btn_cancel: 'Cancelar',
  device_groups_tooltip_edit: 'Editar',
  device_groups_tooltip_delete: 'Borrar',
  device_groups_color_picker_label: 'Color del grupo de dispositivos',

  device_groups_name: 'Nombre',
  device_groups_devices: 'Dispositivos',
  device_groups_view_devices: 'Ver {{count}} dispositivos',
  device_groups_group_name: 'Nombre del grupo',
  device_groups_parent_device_group: 'Grupo padre de dispositivos',
  device_groups_auto_device_group_type_label: 'Grupo automático de dispositivos',
  device_groups_auto_device_group_type_none: 'Sin grupo automático',
  device_groups_auto_device_group_type_all_devices: 'Todos los dispositivos',
  device_groups_auto_device_group_type_all_water: 'Todos los dispositivos de agua',
  device_groups_auto_device_group_type_all_energy: 'Todos los dispositivos de energía',
  device_groups_auto_device_group_type_all_pressure: 'Todos los sensores de presión',
  device_groups_auto_device_group_type_all_barometric_pressure:
    'Todos los sensores de presión barométrica',
  device_groups_auto_device_group_type_all_levels: 'Todos los sensores de nivel',
  device_groups_auto_device_group_type_all_soil_moisture: 'Todos los sensores de humedad del suelo',
  device_groups_auto_device_group_type_all_air_humidity: 'Todos los sensores de humedad del aire',
  device_groups_auto_device_group_type_all_temperatures: 'Todos los sensores de temperatura',
  device_groups_auto_device_group_type_all_pm10: 'Todos los sensores PM10',
  device_groups_auto_device_group_type_all_pm2_5: 'Todos los sensores PM2.5',
  device_groups_auto_device_group_type_unknown: 'Grupo automático desconocido',
  device_groups_auto_device_group_alert_title: 'Grupo automático de dispositivos habilitado',
  device_groups_auto_device_group_alert_description: 'Este grupo está configurado como {{type}}.',
  device_groups_auto_device_group_change: 'Cambiar',
  device_groups_auto_device_group_change_modal_title: 'Cambiar grupo automático de dispositivos',
  device_groups_menuitem_none: 'Ninguno',
  device_groups_add_device_group: 'Agregar grupo de dispositivos',
  device_groups_edit_device_group: 'Editar grupo de dispositivos',
  device_groups_delete_device_group: 'Eliminar grupo de dispositivos',

  device_grous_add_sensor_device: 'Agregar sensor y dispositivo al grupo',

  device_groups_table_sensor_group_name_header: 'Nombre del grupo de sensores',
  device_groups_table_parent_group_name_header: 'Nombre del grupo principal',
  device_groups_table_device_count_header: 'Recuento de dispositivos',

  device_groups_sensor_table_device_number_header: 'Serie de dispositivo',
  device_groups_sensor_table_sensor_name_header: 'Nombre del sensor',
  device_groups_sensor_table_sensor_index_header: 'Lectura del sensor',
  device_groups_sensor_table_select_message: 'Seleccionar un grupo de sensores',

  device_groups_sensors_add_modal_device_placeholder: 'serie del dispositivo',
  device_groups_sensors_add_modal_sensor_placeholder: 'Sensor',
  device_groups_sensors_add_modal_device_group_name_required:
    'El nombre del grupo de dispositivos es obligatorio',

  device_groups_sensors_delete_description:
    'La eliminación de esta configuración la eliminará permanentemente del servidor.',
  device_groups_device_group_delete_description:
    'La eliminación del grupo de dispositivos lo eliminará permanentemente del servidor.',

  device_groups_select_company_header: 'Seleccione una empresa para continuar',
  device_groups_select_company_from: 'Desde aquí: ',
  device_groups_select_company_accounts_page_link: 'Página de Cuentas',

  device_groups_create_device_group_error:
    'Hubo un problema al crear un nuevo grupo de dispositivos',
  device_groups_update_device_group_error:
    'Hubo un problema al actualizar el grupo de dispositivos',
  device_groups_delete_device_group_error: 'Hubo un problema al eliminar el grupo de dispositivos',
  device_groups_add_device_sensor_device_group_error: 'Hubo un problema al agregar el sensor',
  device_groups_remove_device_sensor_device_group_error: 'Hubo un problema al eliminar el sensor',

  /*
   * |==============|
   * | Users Config |
   * |==============|
   */

  //Page
  users_header: 'Usuarios',
  users_table_username: 'Nombre de usuario',
  users_table_first_name: 'Nombre',
  users_table_last_name: 'Apellido',
  users_table_company_name: 'Cuenta',
  users_table_email: 'Correo electrónico',

  //Filters
  users_filter_username: 'Filtrar nombre de usuario',
  users_filter_first_name: 'Filtrar nombre',
  users_filter_last_name: 'Filtrar apellido',
  users_filter_email: 'Filtrar correo electrónico',
  users_filter_company_name: 'Filtrar cuenta',
  users_reset_filter_icon: 'Restablecer filtros',
  users_table_is_contact_person: 'Persona de contacto',

  //Modals
  users_add_modal_header: 'Agregar usuario',
  users_update_modal_header: 'Actualizar usuario',
  user_remove_modal_icon: 'Eliminar usuario',
  users_remove_modal_header: '¿Está seguro de que desea eliminar el usuario {{username}}?',
  users_remove_modal_body:
    'Al hacer clic en eliminar, se eliminará permanentemente del servidor al usuario elegido.',
  users_is_dashboard_enabled: 'Tablero Habilitado',
  users_is_contact_person: 'Persona de Contacto',

  //Errors
  users_password_match: 'Las contraseñas no coinciden',
  users_email_blank: 'El correo electrónico no puede estar en blanco',
  users_load_error: 'No se pudieron cargar los usuarios',
  users_update_error: 'No se pudo actualizar el usuario',
  users_delete_error: 'No se pudo eliminar el usuario',
  users_create_error: 'No se pudo crear el usuario',

  // Success
  users_update_success: 'Usuario actualizado con éxito',
  users_delete_success: 'Usuario eliminado con éxito',
  users_create_success: 'Usuario creado con éxito',
  /*
   * |=====================|
   * | Value Ranges Config |
   * |=====================|
   */

  // Buttons & tooltips
  value_ranges_btn_add: 'Agregar',
  value_ranges_btn_defaults: 'Valores predeterminados',
  value_ranges_line_color: 'Color de linea',
  value_ranges_node_color: 'Color de nodo',
  value_ranges_foreground_color: 'Color de primer plano',
  value_ranges_background_color: 'Color de fondo',
  value_ranges_loading: 'Cargando...',
  value_ranges_nothing_to_show: 'Nada que mostrar',

  //Page
  value_ranges_header: 'Eventos de rango de valor',
  value_ranges_trigger: 'activar',
  value_ranges_notifications: 'notificaciones',
  value_ranges_before: 'Antes',
  value_ranges_after: 'Después',
  value_ranges_disabled: 'Desactivado',
  value_ranges_date_range: 'Rango de fechas',
  value_ranges_daily_time_slot: 'Franja horaria diaria',
  value_ranges_timezone: 'Zona horaria',

  //Modals
  value_ranges_add_event: 'Añadir evento',
  value_ranges_edit_event: 'Editar evento',
  value_ranges_add_default_events: 'Agregar eventos predeterminados',
  value_ranges_remove_modal_header: '¿Está seguro de que desea eliminar el rango de valores',
  value_ranges_remove_modal_body:
    'Al hacer clic en eliminar, se eliminará permanentemente el rango de valores elegido',

  //Form
  value_range_form_name: 'Nombre del evento',
  value_range_form_function: 'Función',
  value_range_form_sensor: 'Sensor',
  value_range_form_description: 'Descripción',
  value_range_form_min: 'Min',
  value_range_form_max: 'Max',
  value_range_form_severity: 'Severidad',
  value_range_form_start_day: 'Día de inicio',
  value_range_form_start_month: 'Mes de inicio',
  value_range_form_start_time: 'Hora de inicio',
  value_range_form_end_day: 'Día final',
  value_range_form_end_month: 'Mes final',
  value_range_form_end_time: 'Hora de finalización',
  value_range_form_enable_events: '¿Habilitar eventos?',
  value_range_form_select_color: 'Color seleccionado',
  value_range_form_notification_email: 'Correo electrónico',
  value_range_form_notification_push_notification: 'Notificación de inserción',
  value_range_form_notification_sms: 'SMS',
  value_range_form_notification_push: 'Notificación de inserción',
  value_range_form_notification_call: 'Llamar',
  value_range_form_line_custom_color: 'Color de línea personalizado',
  value_range_form_marker_custom_color: 'Color de marcador personalizado',
  value_range_form_no_notifications: 'No Notificaciones',

  //Errors

  value_range_tooltip_severity:
    'Las severidades mayores a 7 se consideran severas. Los eventos severos se indican con un signo de exclamación.',
  value_range_error_add: 'No se pudo agregar el evento',
  value_range_error_edit: 'No se pudo editar el evento',
  value_range_name_is_required: 'Se requiere el nombre',
  value_range_name_already_exists: 'El nombre del evento ya existe para este dispositivo y sensor',
  value_range_min_greater_than_max: 'Min no puede ser mayor que max',
  value_range_min_equal_to_max: 'Min no puede ser igual a max',
  value_range_name_incorect_time: 'Formato de hora incorrecto',
  value_range_min_max_is_required: 'Mínima o máxima es requerida',
  value_range_error_occured: 'An error occureOcurrió un errord',
  value_range_start_incorrect_time:
    'La hora de inicio tiene un formato incorrecto. Debería ser HH: mm. Correcto: 01:00. Incorrecto: 1:00.',
  value_range_end_incorrect_time:
    'La hora de finalización tiene un formato incorrecto. Debería ser HH: mm. Correcto: 01:00. Incorrecto: 1:00.',
  value_range_start_day_missing_start_month: 'El día de inicio debe tener el mes de inicio',
  value_range_end_day_missing_end_month: 'El día de finalización debe tener el mes de finalización',
  value_range_start_month_missing_start_day: 'El mes de inicio debe tener el día de inicio',
  value_range_end_month_missing_end_day: 'El mes final debe tener el día final',
  value_range_mixed_alphabets_error: 'Se detectó el uso de alfabetos mixtos, use solo un idioma',

  /*
   * |==========|
   * | Commands |
   * |==========|
   */

  // Command State
  commands_command_state_pending: 'Pendiente',
  commands_command_state_sent: 'Enviado',
  commands_command_state_cancelled: 'Cancelado',
  commands_command_state_status_ok: 'OK',
  commands_command_state_status_nok: 'No OK',
  commands_command_state_unknown: 'Desconocido',
  commands_command_state_timeout: 'Tiempo de espera agotado',

  // Command Type
  commands_command_type_relay_switch: 'Interruptor de relé',
  commands_command_type_single_relay_switch: 'Interruptor de relé único',
  commands_command_type_relay_switch_with_delay: 'Swith del Relay con Delay',
  commands_command_type_relay_statuses: 'Estados de los relés',
  commands_command_type_send_config_over_mqtt: 'Enviar configuración a través de MQTT',
  commands_command_type_send_date_over_mqtt: 'Enviar fecha a través de MQTT',
  commands_command_type_modbus: 'Modbus',
  commands_command_type_tasmota_relay_switch: 'Comando de relé Tasmota',
  commands_command_type_reset: 'Reiniciar',
  commands_command_type_scheduled_relay_command: 'Comando de relé programado',
  commands_command_type_scheduled_relay_command_4: 'Comandos de relé programados (4)',

  // Errors
  commands_error_missing_device_number: 'Serie Dispositivo faltante o errónea.',

  // Buttons
  commands_btn_send_command: 'Enviar Comando',
  commands_btn_refresh: 'Actualizar',
  commands_btn_submit: 'Enviar',

  // Tooltips
  commands_tooltip_edit: 'Editar',

  // Popups
  commands_send_command: 'Enviar Comando',
  commands_edit_command: 'Editar Comando',
  commands_command_type: 'Tipo de Comando',
  commands_parameters: 'Parámetros',
  commands_parameter_name: 'Nombre Parámetro',
  commands_parameter_value: 'Valor Parámetro',

  // Page
  commands_header: 'Comandos',
  commands_type: 'Tipo',
  commands_status: 'Estado',
  commands_relay_1_status: 'Estado del Relay 1',
  commands_relay_2_status: 'Estado del Relay 2',
  commands_created: 'Creado',
  commands_sent: 'Enviado',
  commands_executed: 'Ejecutado',
  commands_relay_status: 'Estado del relé',
  commands_relay_index: 'Índice del relé',

  commands_sensor_index: 'Índice del sensor',
  commands_slave_device_number: 'Número de dispositivo esclavo',
  commands_hour: 'Hora',
  commands_minutes: 'Minutos',
  commands_auto_refresh: 'Actualización automática',
  commands_no_commands: 'Todavía no se han enviado comandos a este dispositivo.',
  commands_no_parameters: 'Este comando no admite parámetros.',
  commands_no_parameter_values: 'No hay valores disponibles para este dispositivo.',
  commands_schedule_group: 'Programación {{index}}',
  commands_cancel_command: 'Cancelar comando',
  commands_cancel_command_confirm:
    'Este comando aún no se ha enviado. Cancelarlo impide que llegue al dispositivo.',
  commands_cancel_command_success: 'Comando cancelado',
  commands_send_command_success: 'Comando enviado',
  commands_btn_close: 'Cerrar',
  commands_btn_keep: 'Mantenerlo',
  commands_parameters_empty: 'Sin parámetros',
  commands_command_id: 'ID',
  commands_error_send_failed: 'No se pudo enviar el comando.',
  commands_error_cancel_failed: 'No se pudo cancelar el comando.',
  commands_error_parameters_failed: 'No se pudieron cargar los parámetros de este comando.',
  commands_only_pending_can_be_cancelled: 'Solo se pueden cancelar los comandos pendientes.',
  commands_last_updated: 'Actualizado a las {{time}}',
  commands_error_list_failed: 'No se pudieron cargar los comandos.',
  commands_range_hint: 'Permitido: {{min}}–{{max}}',

  /*
   * |=============|
   * | Copy Config |
   * |=============|
   */

  // Page
  copy_config_copy_config: 'Copiar Configuración',
  copy_config_to_device_number_with_name_absent: 'Al dispositivo: {{device_number}}',
  copy_config_to_device_number_with_name_present:
    'Al dispositivo: {{device_name}} ({{device_number}})',
  copy_config_from_device_number: 'Del serie del dispositivo',
  copy_config_copy_config_type_label: 'Tipo de copia de configuración',
  copy_config_existing_device_option: 'Dispositivo existente',
  copy_config_new_device_option: 'Nuevo dispositivo',
  copy_config_should_copy_label: 'Debe copiarse:',
  copy_config_should_copy_config_option: 'Configuración',
  copy_config_should_copy_value_ranges_option: 'Rangos de valores',

  // Buttons
  copy_config_btn_copy: 'Dupdo',

  //Toast
  copy_config_toast_copied_success: 'La configuración del dispositivo se copió correctamente.',
  copy_config_toast_copied_error:
    'Hubo un problema al intentar copiar la configuración del dispositivo.',
  copy_config_value_ranges_toast_copied_success: 'Los rangos de valores se copiaron con éxito.',
  copy_config_value_ranges_toast_copied_error:
    'Hubo un problema al intentar copiar los rangos de valores.',

  /*
   * |============|
   * | Statistics |
   * |============|
   */
  statistics_header: 'Estadísticas',
  statistics_header_hours: 'Horas',
  statistics_header_quantity: 'Cantidad',
  statistics_header_value: 'Valor',
  statistics_quantity_minimum: 'Mínimo',
  statistics_quantity_maximum: 'Máximo',
  statistics_quantity_average: 'Promedio',
  statistics_quantity_total: 'Total',
  statistics_quantity_hours: 'Horas',
  statistics_quantity_counters: 'Contadores',
  statistics_error_title: 'Estadisticas no disponibles',
  statistics_error_missing_config_title: 'La configuracion del medidor de agua esta incompleta',
  statistics_error_missing_config_description:
    'Para calcular las estadisticas, el diametro, q3 y r deben estar definidos para cada medidor de agua. Revise los valores actuales a continuacion y complete los que faltan.',
  statistics_error_missing_field: 'Falta {{field}}',
  statistics_error_not_defined: 'No definido',
  statistics_error_open_sensor_config: 'Abrir configuracion del sensor',
  statistics_error_update_values_hint: 'Actualice los valores que faltan y vuelva a esta pagina.',
  statistics_error_contact_admin:
    'Pongase en contacto con un administrador y pidale que defina los valores de configuracion que faltan del medidor de agua.',
  statistics_error_flow_unit_not_configured:
    'El sensor seleccionado no tiene una unidad de caudal configurada.',

  // Error
  statistics_error_definition_for_q3:
    'El sensor {{name}} contiene una definición para q3. Consulte la página de configuración del sensor.',
  statistics_eror_definition_for_diameter:
    'El sensor {{name}} contiene una definición de diámetro. Consulte la página de configuración del sensor.',
  statistics_error_definition_for_r:
    'El sensor {{name}} contiene una definición para r. Consulte la página de configuración del sensor.',
  statistics_error_no_water_meters_found:
    'No se encontraron medidores de agua. Visite la página de configuración del dispositivo.',

  /*
   * |=====|
   * | Map |
   * |=====|
   */
  map_add_device: 'Añadir {{device}}',
  map_edit_device: 'Editar {{device}}',
  map_lat: 'Latitud',
  map_long: 'Longitud',
  map_coordinates: 'Coordenadas',
  map_polygon: 'Polígono',
  map_linked_in_polygons: 'Contenido en polígonos:',
  map_loading: 'Cargando...',

  // Button
  map_btn_link_device: 'Dispositivo de enlace',
  map_btn_submit: 'Enviar',

  // Error
  map_err_add_device_to_map: 'No se pudo agregar el dispositivo al mapa.',
  map_err_change_location: 'No se pudo cambiar la ubicación.',
  map_err_link_polygon: 'No se pudo vincular al polígono.',

  // Device Modal
  map_btn_get_curr_location: 'Obtener ubicación actual',
  map_geolocation_not_supported: 'La geolocalización no es compatible por este navegador.',
  map_lat_validation_message: 'Latitud no válida',
  map_long_validation_message: 'Longitud no válida',
  map_invalid_location: 'Locación inválida',
  map_invalid_coordinate_input:
    'Entrada de coordenadas no válida. Debería ser "lat, long", p.e. 42.123, 23.123',

  // Set Coordinates Modal
  map_coordinates_modal_btn_label: 'Establecer Coordenadas',
  map_coordinates_modal_title: 'Establecer Coordenadas',
  map_coordinates_modal_target_option_self: 'Para uno mismo',
  map_coordinates_modal_target_option_company: 'Para la Empresa',
  map_coordinates_modal_target_option_user: 'Para el Usuario',
  map_coordinates_modal_select_user_autocomplete_label: 'Nombre de Usuario',
  map_coordinates_modal_save_for_self_warning_message:
    'Guardar establecerá las coordenadas actuales como predeterminadas para su usuario actual. ¿Está seguro de que desea continuar?',
  map_coordinates_modal_save_for_company_warning_message:
    'Guardar establecerá las coordenadas actuales como predeterminadas para cada usuario en su empresa. ¿Está seguro de que desea continuar?',
  map_coordinates_modal_save_for_user_warning_message:
    'Guardar establecerá las coordenadas actuales como predeterminadas para el usuario seleccionado. ¿Está seguro de que desea continuar?',
  map_coordinates_modal_confirm_btn_label: 'Confirmar',
  map_coordinates_modal_cancel_btn_label: 'Cancelar',

  /*
   * |===============|
   * | Sensor Config |
   * |===============|
   */

  flow_time_units: 'Unidad de tiempo',
  flow_measurement_units: 'Unidad de medida',
  flow_configuration_label: 'Configuración de flujo',
  flow_coefficient: 'Coeficiente',
  sensor_config_sensor_group_name: 'Nombre del grupo de sensores',
  flow_configuration_alert_message:
    'Compruebe las siguientes configuraciones de flujo:\n{{message}}',
  flow_configuration_invalid_sensor_row_message:
    'Índice: {{sensor_index}} con nombre: {{sensor_name}}\n',
  flow_configuration_sensor_name_not_set_label: 'No establecido',

  /*
   * |===================|
   * | Device Prediction |
   * |===================|
   */
  device_prediction: 'Predicción de dispositivos',
  device_prediction_header: 'Análisis de series temporales',
  device_prediction_sensor_name: 'Nombre del sensor',
  device_prediction_forward_days: 'Días futuros',
  device_prediction_backward_days: 'Días hacia atrás',
  device_prediction_generate_btn: 'Generar',
  device_prediction_error: 'Error',
  device_prediction_error_msg_json: 'Hubo un problema al generar datos de predicción.',
  device_prediction_error_msg_image: 'Hubo un problema al generar la imagen de predicción.',
  device_prediction_date: 'Fecha',
  device_prediction_trend: 'Tendencia',
  device_prediction_time: 'Hora',
  device_prediction_legend_prediction: 'Predicción',
  device_prediction_legend_range: 'Rango de predicción',
  device_prediction_legend_consumption: 'Consumo actual',
  device_prediction_help_title: 'Ayuda',
  device_prediction_help_title_input_guide: 'Guía de Entrada',
  device_prediction_help_input_guide_text:
    '<strong> 1. Período </strong> - Los usuarios pueden seleccionar un rango de fechas entre opciones predefinidas o establecer un rango personalizado. El sistema analiza los datos dentro de este período elegido para calcular predicciones futuras, ofreciendo información valiosa. <br> <strong> 2. Nombre del Sensor </strong> – selecciona el sensor del cual deseas ver sus predicciones futuras. <br> <strong> 3. Cada </strong> - se utiliza para predicciones más detalladas en términos de la granularidad del tiempo. <br> <strong> 4. Días hacia adelante </strong> - número de días en los que el usuario desea predecir en el futuro. Estas predicciones se extienden más allá del rango de fechas seleccionado, dando ideas sobre el comportamiento esperado de consumo. <br> <strong> 5. Días hacia atrás </strong> - representa el número de días a mostrar en el gráfico y la tabla, comenzando desde el último día del período seleccionado. Esto muestra los datos reales históricos recibidos del dispositivo durante este período especificado. <br> <strong> 6. Botón Generar </strong> – al hacer clic en "Generar", el sistema calcula el consumo en función de la configuración seleccionada y genera predicciones. Los resultados se muestran tanto en la Vista de Gráficos como en la Vista de Tabla. <br> <strong> 7. Gráfico </strong> – El gráfico muestra tanto los días hacia adelante como los días hacia atrás, presentando los datos reales recibidos y mostrando los datos predichos. <br> <strong> 8. Tabla </strong> - La tabla muestra todos los datos desde "desde el período" hasta el final de los "días hacia adelante". Cada fila incluye una fecha específica, hora y valor de tendencia correspondiente, indicando la dirección o patrón general de los datos a lo largo del tiempo. Ayuda a comprender si los valores están aumentando, disminuyendo o siendo estables durante el período predicho.',
  device_prediction_help_title_legend: 'Leyenda',
  device_prediction_help_black:
    '<strong> Color Negro </strong> - representa los datos reales de consumo durante el período seleccionado (ejemplo: desde el 01 de julio hasta el 31 de julio).',
  device_prediction_help_red:
    '<strong> Color Rojo </strong> - Representa el consumo real si hay datos fuera del período seleccionado. En la imagen de arriba, hay datos reales recibidos del dispositivo en los días en que el modelo está configurado para predecir. Así, el usuario puede comparar los valores predichos (azul oscuro) con los valores en rojo (datos reales).',
  device_prediction_help_dark_blue:
    ' <strong> Color Azul Oscuro </strong> - Representa la predicción para el período seleccionado, que incluye datos antiguos y se extiende hacia el futuro con los valores predichos de los días hacia adelante. Estos valores predichos ofrecen información sobre la tendencia esperada de consumo.',
  device_prediction_help_light_blue:
    '<strong> Color Azul Claro </strong> - Representa el rango de los valores predichos. Indica que los datos de consumo reales podrían encontrarse dentro de este rango, lo que señala la incertidumbre asociada con las predicciones.',
  device_prediction_help_example:
    "Si la fecha 'DESDE' se establece en el 1 de julio y la fecha 'HASTA' en el 31 de julio, con 'Días hacia adelante' de 30, 'Días hacia atrás' de 30 y 'CADA' 10 minutos, el gráfico mostrará el consumo real de los 30 días disponibles (del 1 de julio al 1 de agosto) y los valores predichos para 30 días hacia adelante (del 1 de agosto al 1 de septiembre). La tabla mostrará el consumo real y predicho para cada intervalo de 10 minutos desde el 1 de julio hasta el 1 de septiembre de 2023.",

  /*
   * |=================|
   * | Counters Export |
   * |=================|
   */

  // Buttons and dropdowns
  counters_export_header: 'Exportar datos',
  counters_readings_header: 'Informes',
  counters_export_search: 'Buscar',
  counters_export_download: 'Descargar',
  counters_export_format: 'Formato',

  // Table columns
  counters_export_table_device_name: 'Nombre del dispositivo',
  counters_export_table_device_number: 'Número del dispositivo',
  counters_export_table_sensor_index: 'Índice de sensores',
  counters_export_table_sensor_name: 'Nombre del sensor',
  counters_export_table_date: 'Fecha',
  counters_export_table_counters: 'Valor',
  counters_export_table_prev_counters: 'Valor anterior',
  counters_export_table_dt: 'Diferencia de tiempo',
  counters_export_table_delta: 'Diferencia',
  counters_export_error_alert_message: 'Ocurrió un error al generar los datos.',
  counter_export_select_devices_label: 'Seleccionar dispositivos',
  counter_export_select_sensors_label: 'Seleccionar sensores',
  counter_export_sensor_index: 'Índice de sensores: {{sensor_index}}',

  counters_export_maximum_capacity_error_message: '¡Capacidad máxima de exportación alcanzada!',
  counters_export_maximum_capacity_suggestion_message:
    'Disminuya la cantidad de dispositivos seleccionados o el período de fecha.',
  counters_export_empty_selection_title: 'Elija qué exportar',
  counters_export_empty_selection_message:
    'Seleccione uno o más dispositivos o grupos de dispositivos para preparar la exportación de lecturas.',
  counters_export_ready_title: 'Selección lista',
  counters_export_ready_message:
    'Se seleccionaron {{devicesCount}} dispositivos y {{groupsCount}} grupos de dispositivos. Haga clic en Buscar para previsualizar los datos o en Descargar para exportarlos.',
  counters_export_selected_device_toast: 'Dispositivo seleccionado: {{deviceNumber}}',
  /*
   * |====================|
   * | Consumption Export |
   * |====================|
   */

  // Buttons and dropdowns
  consumption_export_header: 'Reporte',
  consumption_export_search: 'Buscar',
  consumption_export_download: 'Descargar',
  consumption_export_format: 'Formato',
  consumption_export_aggregation_period: 'Período de Agregación',
  consumption_export_aggregation_options_none: 'Ninguno',
  consumption_export_aggregation_options_daily: 'Diario',
  consumption_export_aggregation_options_weekly: 'Semanal',
  consumption_export_aggregation_options_monthly: 'Mensual',
  consumption_export_aggregation_options_yearly: 'Anual',

  // Table columns
  consumption_export_table_device_number: 'Número del dispositivo',
  consumption_export_table_sensor_index: 'Índice de sensores',
  consumption_export_table_address: 'Dirección',
  consumption_export_table_sensor_name: 'Nombre del sensor',
  consumption_export_table_first_reading_date: 'Fecha del primer valor',
  consumption_export_table_first_reading_value: 'Primer valor',
  consumption_export_table_last_reading_date: 'Fecha del último valor',
  consumption_export_table_last_reading_value: 'Último valor',
  consumption_export_table_delta: 'Diferencia',
  consumption_export_table_average: 'Promedio',
  consumption_export_table_consumption_for_period: 'Consumo para el período',
  consumption_export_empty_selection_title: 'Elija qué exportar',
  consumption_export_empty_selection_message:
    'Seleccione uno o más dispositivos o grupos de dispositivos para preparar la exportación de consumo.',
  consumption_export_ready_title: 'Selección lista',
  consumption_export_ready_message:
    'Se seleccionaron {{devicesCount}} dispositivos y {{groupsCount}} grupos de dispositivos. Haga clic en Buscar para previsualizar los datos o en Descargar para exportarlos.',
  consumption_export_selected_device_toast: 'Dispositivo seleccionado: {{deviceNumber}}',

  /*
   * |=================|
   * | Alarms Export |
   * |=================|
   */

  // Buttons and dropdowns
  alarms_export_header: 'Alarmas',
  alarms_export_search: 'Buscar',
  alarms_export_refresh: 'Actualizar',
  alarms_export_download: 'Descargar',
  alarms_export_format: 'Formato',

  alarms_return_to_alarms: 'Volver a Alarmas',
  alarms_redirect_to_graph: 'Redirigir al gráfico',

  // Table columns
  alarms_export_table_date: 'Fecha',
  alarms_export_table_device_number: 'Número del dispositivo',
  alarms_export_table_device_name: 'Nombre del dispositivo',
  alarms_export_table_severity: 'Gravedad',
  alarm_severity_tooltip: 'Gravedad: {{value}} de 10',
  alarm_severity_none_tooltip: 'No se ha informado gravedad para esta alarma',
  alarms_export_table_sensor_index: 'Índice de sensores',
  alarms_export_table_sensor_name: 'Nombre del sensor',
  alarms_export_table_alarm_type: 'Tipo',
  alarms_export_table_alarm_status: 'Estado',
  alarms_export_table_description: 'Descripción',
  alarms_export_table_link_to_graph: 'Enlace al gráfico',
  alarms_export_chip_status_active: 'Activo',
  alarms_export_chip_status_inactive: 'Inactivo',
  alarms_export_switch_title_label: 'Autorefrescar',
  alarms_export_error_alert_message: 'Ocurrió un error al generar los datos.',
  alarms_export_select_company_alert_message: 'Seleccione una empresa antes de buscar alarmas',
  alarms_export_select_device_or_company_alert_message:
    'Seleccione un dispositivo o una empresa antes de buscar alarmas',
  alarms_export_error_too_big_query:
    'Recuperar el historial de Super-Administrador para todos los dispositivos es una solicitud demasiado grande. Seleccione una empresa.',

  /*
   * |================|
   * | Inventory page |
   * |================|
   */

  //table
  device_inventory_page_header: 'Inventario',
  device_inventory_column_header_search: 'Buscar…',
  device_inventory_description: 'Descripción',
  device_inventory_device_name: 'Nombre del dispositivo',
  device_inventory_device_number: 'Número del dispositivo',
  device_inventory_hardware_version: 'Versión del hardware',
  device_inventory_model: 'Modelo',
  device_inventory_software_version: 'Versión del software',
  device_inventory_actions: 'Acciones',
  nomenclature: 'Nomenclatura',

  //modal
  device_inventory_manual: 'Manual',
  device_inventory_template: 'Plantilla',
  device_inventory_add_device: 'Agregar dispositivo',
  device_inventory_create_device_button: 'Crear dispositivo',
  device_inventory_delete_unlink_modal_body:
    'Esto eliminará permanentemente el dispositivo elegido o puede desvincularlo de la empresa seleccionada. El dispositivo se desvinculará de la cuenta actual y de todas las subcuentas. Si desea desvincular el dispositivo solo de la cuenta actual, visite la página "Vincular dispositivo".',
  device_inventory_delete_modal_body: 'Esto eliminará permanentemente el dispositivo elegido.',
  device_inventory_hardware_version_helper: 'El formato requerido es X.X.X donde X es un número',
  device_inventory_update_device_button: 'Actualizar dispositivo',
  device_inventory_update_device_title: 'Actualizando {{number}}',
  device_inventory_modal_delete_device_title: 'Eliminar dispositivo {{number}}',
  device_inventory_software_version_helper:
    'El formato requerido es X.X.X o X.X.X- y X.X.X_ seguido de caracteres, donde X es un número',
  device_inventory_description_helper: 'Límite de caracteres de la descripción alcanzado',
  device_inventory_device_number_helper:
    'Por favor, ingrese 8 caracteres que contengan solo letras (A-Z) y números (0-9).',
  device_inventory_modal_select_action: 'Seleccionar acción para el dispositivo {{deviceNumber}}',
  device_inventory_reference_device_number: 'Seleccionar dispositivo para referencia',
  device_inventory_nomenclature_required_for_model: 'La nomenclatura es requerida para {{model}}',

  //success
  device_inventory_create_device_success: 'Dispositivo creado con éxito',
  device_inventory_update_device_success: 'Dispositivo actualizado con éxito',
  device_inventory_delete_device_success: 'Dispositivo eliminado con éxito',
  device_inventory_unlink_device_success: 'Dispositivo desvinculado con éxito',
  device_inventory_rma_add_success: 'Registro RMA añadido correctamente',
  device_inventory_rma_history_title: 'Historial RMA - {{number}}',
  device_inventory_rma_add_record: 'Añadir registro',
  device_inventory_rma_no_records: 'No hay registros RMA para este dispositivo',
  device_inventory_rma_add_error: 'Se produjo un error al añadir el registro RMA',
  rma_record_date: 'Fecha',
  rma_record_date_required: 'La fecha es obligatoria',
  rma_record_type: 'Tipo',
  rma_record_category: 'Categoría',
  rma_record_comments: 'Comentarios',
  rma_record_save: 'Guardar',
  rma_record_back: 'Atrás',
  rma_type_INCIDENT: 'Incidente',
  rma_type_DEVICE_EVENT: 'Evento del dispositivo',
  rma_type_RMA: 'RMA',
  rma_category_BATTERY_REPLACEMENT: 'Reemplazo de batería',
  rma_category_SIM_CARD_CHANGE: 'Cambio de tarjeta SIM',
  rma_category_ENCLOSURE_DEGRADATION: 'Degradación de la carcasa',
  rma_category_FLOOD_DAMAGE: 'Daño por inundación',
  rma_category_ANTENNA_REPLACEMENT: 'Reemplazo de antena',
  rma_category_POWER_SUPPLY_PROBLEM: 'Problema de alimentación',
  rma_category_PHYSICAL_DAMAGE: 'Daño físico',
  rma_category_STOLEN: 'Robado',
  rma_category_WRONG_CONFIGURATION: 'Configuración incorrecta',
  rma_category_OTHER: 'Otro',

  //error
  device_inventory_create_device_error: 'Se produjo un error al crear el dispositivo',
  device_inventory_delete_device_error: 'Se produjo un error al eliminar el dispositivo',
  device_inventory_device_exists: 'El dispositivo ya existe',
  device_inventory_empty_device_error: 'El número del dispositivo no puede estar vacío',
  device_inventory_empty_reference_error: 'Seleccione un dispositivo para referencia',
  device_inventory_empty_device_name_error: 'El nombre del dispositivo no puede estar vacío',
  device_inventory_empty_hardware_error: 'La versión del hardware no puede estar vacía',
  device_inventory_empty_software_error: 'La versión del software no puede estar vacía',
  device_inventory_error: 'No se pudieron cargar los dispositivos',
  device_inventory_update_device_error: 'Se produjo un error al actualizar el dispositivo',
  device_inventory_already_exists_error: 'El dispositivo con este número ya existe',
  device_inventory_empty_nomenclature_error: 'La nomenclatura no puede estar vacía',
  device_inventory_empty_manufacturing_date_error: 'La fecha de fabricación no puede estar vacía',
  device_inventory_empty_warranty_period_error: 'El período de garantía no puede estar vacío',

  /*
   * |====================|
   * | Transmissions page |
   * |====================|
   */

  //page
  transmissions_page_title: 'Transmisiones',
  transmissions_page_refresh: 'Actualizar',
  transmissions_page_export_csv: 'Exportar a CSV',
  transmissions_page_error_message: 'No se pudieron cargar las transmisiones',

  //table
  transmissions_table_device_number: 'Número de dispositivo',
  transmissions_table_device_name: 'Nombre del dispositivo',
  transmissions_table_last_transmission: 'Última transmisión',
  transmissions_table_next_transmission: 'Próxima transmisión',
  transmissions_table_days: 'Días',
  transmissions_table_transmission: 'Transmisión',
  transmissions_table_count: 'Cantidad',
  transmissions_table_customer: 'Cliente',
  transmissions_table_address: 'Dirección',
  transmissions_table_ok: 'OK',
  transmissions_table_devEUI: 'devEUI',
  transmissions_table_simcard_number: 'Número de Tarjeta SIM',
  transmissions_table_simcard_provider: 'Proveedor de Tarjeta SIM',
  transmissions_table_apn: 'APN',

  /*
   * |===============|
   * | Device Config |
   * |===============|
   */

  // page
  device_config_period: 'Período',
  device_config_every: 'Cada',

  // error
  device_config_error_record_period_postiive: 'El período de registro debe ser positivo.',
  device_config_error_transmission_period_positive: 'El período de transmisión debe ser positivo.',
  device_config_error_record_must_be_greater_than_transmission:
    'El período de registro no puede ser mayor que el período de transmisión.',
  device_config_error_not_divisible:
    'El período de registro no es divisible al período de transmisión.',
  device_config_error_max_threshold_reached:
    '{{curr}} registros por transmisión es más que el máximo {{max}}.',

  /*
   * |=======|
   * | Graph |
   * |=======|
   */
  graph_tabs_readings: 'Valores',
  graph_tabs_prediction: 'Predicción',
  graph_tabs_average: 'Promedio',
  graph_tabs_previous: 'Anterior',
  graph_column_sensor: 'Sensor',
  graph_column_index: 'Índice',
  graph_column_device: 'Dispositivo',
  graph_column_device_name: 'Nombre del dispositivo',
  graph_column_date: 'Fecha',
  graph_column_readings: 'Valor',
  graph_column_previous_readings: 'Valor anterior',
  graph_column_delta: 'Diferencia',
  /*
   * |===============|
   * | Settings page |
   * |===============|
   */
  settings_page_header: 'Configuraciones',
  settings_submit_success_msg: 'Configuraciones guardadas',
  settings_submit_error_msg: 'Las configuraciones no pudieron ser guardadas',
  settings_input_invalid_format_error_msg: 'Formato de datos inválido',
  settings_certificate_not_found_error: 'No se encontró un certificado en esta ruta de archivo',
  settings_add_button: 'Agregar',
  settings_submit_button: 'Enviar',
  settings_input_key_label: 'Clave',
  settings_input_type_label: 'Tipo',
  settings_input_value_label: 'Valor',
  settings_select_type_string: 'Cadena',
  settings_select_type_number: 'Número',
  settings_select_type_boolean: 'Booleano',
  settings_select_type_object: 'Objeto',
  settings_logo_label: 'Logo',
  settings_dashboard_layout_label: 'Diseño del tablero',
  settings_certificate_label: 'Ruta del certificado',
  settings_device_panel_title: 'Título del panel de dispositivo',
  settings_sensor_panel_title: 'Título del panel de sensor',
  settings_header_home_label: 'Etiqueta de inicio (Portal)',
  settings_header_dashboard_label: 'Etiqueta del tablero (Portal)',
  settings_footer_main_label: 'Etiqueta principal del pie de página (Portal)',
  settings_footer_link_label: 'Etiqueta de enlace del pie de página (Portal)',
  settings_footer_link_url: 'URL de enlace del pie de página (Portal)',
  settings_alarm_notification_display_period:
    'Período de visualización de notificaciones de alarma (horas) (Portal)',

  /* |===========|
   * | New Graph |
   * |===========|
   */

  //page
  new_graph_add_device_group_modal_title:
    'Configuración de sensores del grupo de dispositivos "Cada"',
  new_graph_add_device_group_modal_device_group: 'Grupo de dispositivos: ',
  new_graph_add_device_group_modal_sensors_to_add: 'Sensores para añadir: ',
  new_graph_add_device_group_modal_every_selector_mode_per_device: 'Por dispositivo',
  new_graph_add_device_group_modal_every_selector_mode_per_sensor: 'Por sensor',
  new_graph_add_device_group_modal_sensor_limit_message:
    '¡No puedes exceder el límite de gráficos de {{graphSensorsLimit}} sensores!',
  new_graph_add_device_group_modal_confirm_button: 'Confirmar',
  new_graph_add_device_group_modal_cancel_button: 'Cancelar',
  new_graph_select_sensor_heading: 'Seleccionar sensor',
  new_graph_date_range_selection: 'Selección de intervalo de fechas',
  new_graph_selected_sensors_heading: 'Sensores seleccionados',
  new_graph_selected_sensors_remove_all_tooltip: 'Borrar todo',
  new_graph_select_company_message: 'Por favor seleccione una empresa',
  new_graph_show_sensors_statistics_label: 'Mostrar estadísticas',

  //sensor selection
  new_graph_device_group_label: 'Grupo de dispositivos',
  new_graph_device_label: 'Dispositivo',
  new_graph_sensor_label: 'Sensor',

  //date range selection
  new_graph_average_days_label: 'Días promedio',
  new_graph_time_series_prediction_period_label: 'Período',
  new_graph_auto_refresh_label: 'Actualizar',
  new_graph_period_picker_heading: 'Período',
  new_graph_average_days_heading: 'Promedio',
  new_graph_time_series_prediction_period_heading: 'Predicción de series temporales',
  new_graph_none_option: 'Ninguno',
  new_graph_day_option_one: '{{count}} día',
  new_graph_day_option_other: '{{count}} días',
  new_graph_week_option_one: '{{count}} semana',
  new_graph_week_option_other: '{{count}} semanas',
  new_graph_month_option_one: '{{count}} mes',
  new_graph_month_option_other: '{{count}} meses',
  new_graph_year_option_one: '{{count}} año',
  new_graph_year_option_other: '{{count}} años',

  //tooltip
  new_graph_current_value_name: 'Actual',
  new_graph_average_value_name: 'Promedio',
  new_graph_prediction_value_name: 'Predicción',

  //error
  new_graph_fetch_device_groups_error:
    'No se pudieron cargar los grupos de dispositivos para la empresa.',
  new_graph_fetch_devices_error: 'No se pudieron cargar los dispositivos para la empresa.',
  new_graph_fetch_device_config_error:
    'No se pudo cargar la configuración del dispositivo seleccionado.',
  new_graph_fetch_device_ports_config_error:
    'No se pudieron cargar los puertos para el dispositivo seleccionado.',
  new_graph_fetch_device_flow_error:
    'No se pudo cargar el flujo para el dispositivo {{deviceName}}.',
  new_graph_fetch_device_flow_avg_error:
    'No se pudo cargar el flujo promedio para el dispositivo {{deviceName}}.',
  new_graph_fetch_device_readings_error: 'No se pudieron cargar las lecturas para {{deviceName}}.',
  new_graph_fetch_device_readings_avg_error:
    'No se pudieron cargar las lecturas promedio para {{deviceName}}.',
  new_graph_fetch_device_on_off_alarms_error:
    'No se pudieron cargar las alarmas de encendido/apagado para {{deviceName}}.',
  new_graph_fetch_device_prediction_error: 'No se pudo cargar la predicción para {{deviceName}}.',
  new_graph_sensor_already_in_state_error: 'Este sensor específico ya se ha agregado a la lista.',

  /* |================|
   * | Billing Report |
   * |================|
   */

  billing_report_header: 'Informe de facturación',
  billing_report_btn_generate: 'Generar',
  billing_report_device_number: 'Número de dispositivo',
  billing_report_first_reading_date: 'Fecha de primera lectura',
  billing_report_last_reading_date: 'Fecha de última lectura',
  billing_report_readings: 'Lecturas',
  billing_report_battery: 'Batería',
  billing_report_signal: 'Señal',
  billing_report_total: 'Total',

  /* |================|
   * | Profile Page   |
   * |================|
   */
  profile_page_change_logo: 'Cambiar logo',
  profile_page_logo_formats_message: 'Formatos aceptables: PNG, JPEG',
  profile_page_name: 'Nombre',
  profile_page_email: 'Email',
  profile_page_language: 'Idioma',
  profile_page_password: 'Contraseña',
  profile_page_change_language: 'Cambiar idioma',
  profile_page_update_license: 'Actualizar licencia',
  profile_page_change_password: 'Cambiar contraseña',
  profile_page_generate: 'Generar',
  profile_page_api_token: 'Token API',
  profile_page_client_id: 'ID de cliente',
  profile_page_client_secret: 'Secreto de cliente',
  profile_page_show_client_id: 'Mostrar ID de cliente',
  profile_page_hide_client_id: 'Ocultar ID de cliente',
  profile_page_show_client_secret: 'Mostrar secreto de cliente',
  profile_page_hide_client_secret: 'Ocultar secreto de cliente',
  profile_page_api_token_label: 'Token API',
  profile_page_api_token_valid_for: 'Válido por {{duration}}.',
  profile_page_copy: 'Copiar',
  profile_page_copied_to_clipboard: 'Copiado al portapapeles.',
  profile_page_failed_to_copy: 'Error al copiar al portapapeles.',
  profile_page_token_generated_success: 'Token generado exitosamente.',
  profile_page_token_generate_error: 'Error al generar el token.',
  profile_page_header: 'Perfil',
  profile_page_user_info_label: 'Información del usuario',
  profile_page_license_label: 'Licencia ',
  profile_page_license_type: 'Tipo de licencia',
  profile_page_valid_from: 'Válido desde',
  profile_page_valid_to: 'Válido hasta',
  profile_page_max_readings: 'Lecturas máximas',
  profile_page_current_count: 'Cuenta actual',
  profile_page_first_reading: 'Primera lectura',
  profile_page_last_reading: 'Última lectura',
  profile_page_license_status: 'Estado',
  profile_page_renew_license_button: 'Renovar licencia',
  profile_page_deactivate_license_button: 'Desactivar licencia',
  profile_page_valid_license: 'Licencia válida',
  profile_page_invalid_license: 'Licencia no válida',
  profile_page_deactivate_license_success_message: 'Licencia desactivada.',
  profile_page_deactivate_license_error_message: 'No se pudo desactivar la licencia.',
  profile_page_deactivate_modal_title: 'Desactivación de licencia',
  profile_page_confirm_button: 'Confirmar',
  profile_page_cancel_button: 'Cancelar',
  profile_page_deactivate_license_modal_description:
    '¿Está seguro de que desea desactivar esta licencia?',
  profile_page_activate_license_modal_description:
    '¿Está seguro de que quiere activar esta licencia?',
  profile_page_activate_modal_title: 'Activación de Licencia',
  profile_page_license_per_device: 'por dispositivo',
  profile_page_license_per_reading: 'por lectura',
  profile_page_license_per_sensor: 'por sensor',
  profile_page_license_per_poc: 'por prueba de concepto (POC)',
  profile_page_license_per_remote_node: 'por nodo remoto',
  profile_page_license_partial: 'parcial',
  profile_page_logo_file_format_error: 'Tipo de archivo inválido. Por favor, suba una imagen.',
  profile_page_logo_size_error:
    'El tamaño del archivo supera 1MB. Por favor, suba una imagen más pequeña.',
  profile_page_version_info: 'Versiones actuales:',

  logo_error_message: 'No se pudo cargar el logotipo de la empresa',

  profile_page_country: 'País',
  profile_page_timezone: 'Zona horaria',
  profile_page_address: 'Dirección',
  profile_page_city: 'Ciudad',
  profile_page_municipality: 'Municipio',
  profile_page_area: 'Área',
  profile_page_zip_code: 'Código postal',
  profile_page_vat_number: 'Número de IVA',
  profile_page_edit: 'Editar cuenta',
  profile_page_update_account_success: 'Cuenta actualizada exitosamente',
  profile_page_license_info: 'Información de la licencia',

  /* |===============|
   * | Utility Rates |
   * |===============|
   */

  util_rates: 'Tarifas de servicios públicos',

  // table
  util_rates_name: 'Nombre',
  util_rates_price: 'Precio',
  util_rates_currency: 'Divisa',
  util_rates_unit: 'Unidad',
  util_rates_private: 'Privado',
  util_rate_company: 'Compañía',
  util_rate_created: 'Creado',
  util_rates_updated: 'Actualizado',
  util_rates_actions: 'Comportamiento',
  util_rates_tooltip_inspect: 'Inspeccionar',

  // modals
  util_rates_add_modal_header: 'Agregar tarifa de servicios públicos',
  util_rates_edit_modal_header: 'Editar {{name}}',
  util_rates_delete_modal_header: 'Borrar {{name}}',
  util_rates_delete_modal_body:
    'Esto eliminará permanentemente la tarifa de servicios públicos elegida.',
  util_rates_confirm: 'Confirmar',
  util_rates_cancel: 'Cancelar',
  util_rates_loading: 'Cargando...',
  util_rates_error: 'Error...',
  util_rates_error_name_exists: 'El nombre ya existe',

  // errors
  util_rate_fetch_company_error: 'No se pudieron cargar empresas',
  util_rate_fetch_util_rates_error: 'No se pudieron cargar las tarifas de servicios públicos',

  // footer
  footer_powered_by: 'Soportado por',
  util_rates_name_required: 'Se requiere nombre',
  util_rates_price_required: 'Se requiere precio',

  /*
   * |=======|
   * | Icons |
   * |=======|
   */
  icon_type: 'Tipo',
  icon_type_device: 'Dispositivo',
  icon_type_sensor: 'Sensor',

  icon_scope: 'Alcance',
  icon_scope_global: 'Global',
  icon_scope_company: 'Compañía',
  icon_scope_device: 'Dispositivo',
  icon_scope_sensor: 'Sensor',

  icon_input_device: 'Dispositivo',
  icon_input_sensor: 'Sensor',
  icon_input_name: 'Nombre',
  icon_input_company: 'Compañía',

  icon_btn_add_icon: 'Agregar icono',
  icon_btn_upload_file: 'Subir archivo',
  icon_btn_cancel: 'Cancelar',
  icon_btn_save: 'Ahorrar',

  icon_table_name: 'Nombre',
  icon_table_scope: 'Alcance',
  icon_table_icon: 'Icono',
  icon_table_actions: 'Comportamiento',

  // errors
  icon_error_update_icon: 'No se pudo actualizar el icono',
  icon_error_unsupported_file_type: 'Tipo de archivo invalido. Solo se permiten JPEG, PNG y SVG.',
  icon_error_error_occured: 'Ocurrió un error',
  icon_error_enter_name: 'Por favor ingrese un nombre',
  icon_error_enter_icon: 'Sube un icono',
  icon_error_select_company: 'Seleccione una empresa',
  icon_error_select_device: 'Seleccione un dispositivo',
  icon_error_select_sensor: 'Seleccione un sensor',

  /*
   * |=========================|
   * | Customer Billing Report |
   * |=========================|
   */
  customer_billing_report_account_id_table_header: 'ID de Cuenta',
  customer_billing_report_description_table_header: 'Descripción',
  customer_billing_report_customer_name_table_header: 'Nombre del Cliente',
  customer_billing_report_street_table_header: 'Calle',
  customer_billing_report_quarter_table_header: 'Trimestre',
  customer_billing_report_last_reading_table_header: 'Última Lectura',
  customer_billing_report_last_reading_date_table_header: 'Fecha de Última Lectura',
  customer_billing_report_device_number_table_header: 'Número de Dispositivo',
  customer_billing_report_last_config_date_table_header: 'Fecha de última configuración',
  customer_billing_report_billing_group_table_header: 'Grupo de Facturación',
  customer_billing_report_meter_serial_table_header: 'Número de serie',
  customer_billing_report_diameter_table_header: 'Diámetro',
  customer_billing_report_meter_brand_table_header: 'Marca',
  customer_billing_report_meter_model_table_header: 'Modelo',
  customer_billing_report_default_error: 'Se ha producido un error al generar el informe',
  customer_billing_report_contract_number_table_header: 'Número de contrato',
  customer_billing_report_device_name_table_header: 'Nombre del dispositivo',
  customer_billing_report_sensor_name_table_header: 'Nombre del sensor',

  //license
  license_license_warning: 'Advertencia de Licencia',
  license_license_warning_per_reading_over_limit_singular: 'del tipo por lectura supera el límite',
  license_license_warning_expire_singular: 'próxima a expirar',
  license_license_warning_per_reading_over_limit_plural: 'del tipo por lecturas superan el límite',
  license_license_warning_expire_plural: 'próximas a expirar',
  license_max_count_error: 'El conteo máximo no puede ser 0',

  license_header: 'Licencia',
  license_table_company_name: 'Nombre de la empresa',
  license_table_license_type: 'Tipo de licencia',
  license_table_max_count: 'Cuenta máxima',
  license_table_valid_from: 'Válido desde',
  license_table_valid_to: 'Válido hasta',
  license_table_first_reading_date: 'Fecha de la primera lectura',
  license_table_last_reading_date: 'Fecha de la última lectura',
  license_table_active: 'Activo',
  license_table_valid: 'Válido',
  license_table_prepaid: 'Prepagada',
  license_table_yes: 'Sí',
  license_table_no: 'No',
  license_table_actions: 'Acciones',

  license_warning_access_hold: 'Acceso a la cuenta en espera',
  license_warning_access_hold_description:
    'Su acceso a la plataforma ha sido suspendido temporalmente debido a un pago no resuelto. Le animamos a que se ponga en contacto con nuestro soporte o se conecte con su representante designado para ayudarle a resolver este asunto.',
  license_warning_no_valid_license: 'No hay licencia válida',
  license_warning_no_valid_license_description:
    'No pudimos encontrar una licencia válida asociada con esta cuenta. Comuníquese con su representante designado o contacte nuestro soporte para obtener ayuda.',
  license_warning_devices_count_limit_reached: 'Límite de Dispositivos Alcanzado',
  license_warning_devices_count_limit_reached_description:
    'Ha alcanzado el número máximo de dispositivos que puede vincular a la cuenta según la licencia. Si desea agregar más, por favor, póngase en contacto con su representante designado o con nuestro soporte para obtener asistencia.',
  license_warning_generic_title: 'Sin licencia',
  license_warning_generic_description: 'No se puede continuar debido a un problema de licencia.',
  license_info_renew_button: 'Renovar Licencia',
  license_info_deactivate_button: 'Desactivar Licencia',
  license_info_renew_modal_button: 'Renovar',
  license_info_used_readings: 'Lecturas utilizadas',
  license_info_readings_left: 'Lecturas restantes',
  license_renew_license_button: 'Renovar',
  license_deactivate_license_button: 'Desactivar',
  license_select_company_warning_message: 'Seleccione una empresa para continuar',
  license_add_button: 'Agregar Licencia',
  license_add_success_message: 'Licencia creada con éxito',
  license_add_error_message: 'Ocurrió un error durante el proceso',
  license_max_devices: 'Máx Dispositivos',
  license_max_readings: 'Máx Informes',
  license_max_sensors: 'Máx Sensores',
  license_company: 'Empresa',
  license_deactivate_warning: 'Esto suspenderá el acceso de los usuarios a la plataforma',
  license_activate_warning: 'Esto restablecerá el acceso de los usuarios a la plataforma',
  license_activate_license_button: 'Activar',
  license_available_licenses: 'Licencias disponibles',
  license_add_license: 'Agregar licencia',
  license_status_active: 'Activo',
  license_status_inactive: 'Inactivo',
  license_info_activate_button: 'Activar licencia',
  license_info_used_devices: 'Dispositivos usados',
  license_info_devices_left: 'Dispositivos restantes',
  license_error_page_access_restricted: 'Acceso restringido',
  license_valid_license_existing: '¡Ya tiene una licencia válida de este tipo!',
  license_conflicting_license_date: 'Hay una licencia válida en el mismo período',

  license_date_range: 'Rango de fechas',
  license_validity_period: 'Período de validez',
  provide_period: 'Por favor proporcione un período',
  license_table_current_count: 'Conteo actual',

  //Password
  change_password: 'Cambiar contraseña',
  current_password: 'Contraseña actual',
  new_password: 'Nueva contraseña',
  confirm_new_password: 'Confirmar nueva contraseña',
  customer_info_saved: 'Información del cliente guardada',

  password_min_length: 'La contraseña debe tener al menos 10 caracteres',
  password_uppercase: 'La contraseña debe contener al menos una letra mayúscula',
  password_lowercase: 'La contraseña debe contener al menos una letra minúscula',
  password_number: 'La contraseña debe contener al menos un número',
  password_special_char: 'La contraseña debe contener al menos un carácter especial',
  password_mismatch: 'Las contraseñas no coinciden',

  /*
   * |=========================|
   * |     Reset Password      |
   * |=========================|
   */
  reset_password_check_email_for_reset_link:
    'Revise su correo electrónico para el enlace de restablecimiento de contraseña',
  reset_password_default_error_message: 'Hubo un error al intentar restablecer su contraseña',
  reset_password_change_password_label: 'Cambiar contraseña',
  reset_password_send_btn: 'Enviar',

  /*
   * |==============================|
   * |  Sensors and Network Config  |
   * |==============================|
   */

  //headers
  sensors_and_network_config_network_config: 'Netzwerkkonfiguration des Geräts',
  sensors_and_network_config_device_details: 'Detalles del dispositivo',
  sensors_and_network_config_add_sensor: 'Sensor hinzufügen',

  //messages
  sensors_and_network_save_success: 'La configuración se guardó correctamente.',
  sensors_and_network_save_error: 'Hubo un problema al guardar la configuración.',
  sensors_and_network_formula_validation_default_error: 'La validación de la fórmula ha fallado.',
  sensors_and_network_config_required_field_error: 'Este campo es obligatorio',

  //labels
  sensors_and_network_config_sensor_index: 'Índice de sensores',
  wildPoint_threshold: 'Umbral de punto atípico',
  scale: 'Escala',
  precision: 'Precisión',
  initial_value: 'Valor inicial',

  //buttons
  sensors_and_network_config_reset_btn: 'Reiniciar',

  //tooltips
  config_tooltip_select_sensor_icon: 'Seleccionar icono del sensor',
  config_tooltip_sensor_name: 'Nombre del sensor',
  config_tooltip_enable_disable_sensor: 'Habilitar/Deshabilitar sensor',
  config_tooltip_reset_sensor: 'Restablecer cambios nuevos para este sensor',
  config_tooltip_reset_all_fields: 'Restablecer todos los campos a los últimos valores guardados',
  config_tooltip_delete_sensor: 'Eliminar sensor',
  config_tooltip_sensor_description: 'Descripción del sensor',
  config_tooltip_sensor_model: 'Modelo del sensor',
  config_tooltip_sensor_serial_number: 'Número de serie del sensor',
  config_tooltip_sensor_manufacturer: 'Fabricante del sensor',
  config_tooltip_sensor_useInSensorsAggregation:
    'Indica si los datos deben ser utilizados por el agregador automático de datos de Thingslog.',
  config_tooltip_sensor_visibility:
    'Determina si el sensor debe ser visible en el portal de soluciones de Thingslog.',
  config_tooltip_sensor_scale:
    'La precisión después del punto decimal para todos los cálculos de la fórmula.',
  config_tooltip_port_formula: 'Usado para la conversión de valores ADC en bruto a mA o V',
  config_tooltip_sensor_formula:
    'Usado para la conversión de X en mA o V al valor medido, por ejemplo, nivel, presión, temperatura y otros.',
  config_tooltip_sensor_pulseRate: 'Cuánto equivale una unidad a un pulso',
  config_tooltip_sensor_offset:
    'Un número (+ o -) que se sumará a las lecturas enviadas por el dispositivo.',
  config_tooltip_sensor_flow_units: 'Unidades de la tasa de flujo - por ejemplo, m3/h o kW/h',
  config_tooltip_sensor_flow_time_units:
    'El período de tiempo utilizado para el cálculo de la unidad - por ejemplo, segundos',
  config_tooltip_sensor_flow_conversion_coefficient:
    'Cuántas unidades de tiempo se necesitan para alcanzar la unidad a partir de las lecturas en bruto',

  config_tooltip_sensor_diameter: 'Diámetro de la tubería',
  config_tooltip_sensor_q3: 'Coeficiente Q3 del medidor de agua',
  config_tooltip_sensor_r: 'Precisión del medidor de agua',
  config_tooltip_wildPoint_threshold:
    'Especifica el cambio máximo permitido entre lecturas consecutivas del sensor. Si se supera, el paquete se marca como defectuoso y se descarta.',

  /*
   * |==============================|
   * |     Documentation Page       |
   * |==============================|
   */
  documentation_title: 'Documentación',
  documentation_platform: 'Documentación de la plataforma',
  documentation_data_logger: 'Documentación del registrador de datos',
  documentation_communication_protocol: 'Documentación del protocolo de comunicación',
  documentation_sign_in_main_menu: 'Registro/Inicio de sesión y menú principal',
  documentation_account_management: 'Gestión de cuentas de ThingsLog',
  documentation_user_management: 'Gestión de usuarios de ThingsLog',
  documentation_data_loggers_configuration:
    'Configuración de los registradores de datos de ThingsLog',
  documentation_alarms_value_range_events:
    'Configuración y revisión de alarmas y eventos de rango de valores de ThingsLog',
  documentation_modbus_slave_devices:
    'Constructor de parámetros de puertos y sensores para dispositivos esclavos modbus',
  documentation_tasmota_devices:
    'Configuración de dispositivos tasmota para trabajar con la plataforma ThingsLog',
  documentation_modbus_setup:
    'Configuración de dispositivos esclavos Modbus para trabajar con controladores ThingsLog',
  documentation_licenses: 'Licencias',
  documentation_old_user_manual: 'Antiguo manual de usuario',
  documentation_data_logger_manual: 'Manual de usuario del registrador de datos Thingslog',
  documentation_data_logger_command_guide: 'Guía de comandos del registrador de datos Thingslog',
  documentation_lora_protocol: 'Protocolo abierto de datos Lora',
  documentation_mqtt_protocol: 'Protocolo de datos abierto MQTT',
  documentation_getting_started_training_guide: 'Guía de formación para empezar',
  documentation_view_pdf: 'Ver PDF',

  /*
   * |=====================|
   * | Device Nodes Page  |
   * |=====================|
   */

  device_nodes_table_no_links_found: 'No se encontraron enlaces de nodos de dispositivos',
  device_nodes_table_error: 'Error al recuperar enlaces de nodos de dispositivos',
  device_nodes_table_source_device_number: 'Número de Dispositivo de Origen',
  device_nodes_table_source_sensor_index: 'Índice de Sensor de Origen',
  device_nodes_table_target_device_number: 'Número de Dispositivo de Destino',
  device_nodes_table_target_sensor_index: 'Índice de Sensor de Destino',
  device_nodes_table_is_active: 'Está Activo',

  device_nodes_create_link: 'Crear Enlace',
  device_nodes_source_device_required: 'El dispositivo de origen es requerido',
  device_nodes_source_device: 'Dispositivo de Origen',
  device_nodes_sensor_index_required: 'El índice del sensor es requerido',
  device_nodes_sensor_index_min: 'El índice del sensor debe ser al menos 0',
  device_nodes_source_sensor_index: 'Índice de Sensor de Origen',
  device_nodes_target_device_required: 'El dispositivo de destino es requerido',
  device_nodes_target_device: 'Dispositivo de Destino',
  device_nodes_target_sensor_index: 'Índice de Sensor de Destino',
  device_nodes_is_active: 'Está Activo',
  device_nodes_create_link_button: 'Crear Enlace',
  device_nodes_same_device_error:
    'El dispositivo de origen y el dispositivo de destino no pueden ser el mismo',

  device_nodes_delete_links: 'Eliminar enlaces',
  device_nodes_device_required: 'El dispositivo es obligatorio',
  device_nodes_device: 'Dispositivo',
  device_nodes_role_required: 'El rol es obligatorio',
  device_nodes_role: 'Rol',
  device_nodes_role_source: 'Origen',
  device_nodes_role_target: 'Destino',
  device_nodes_sensor_index: 'Sensor (Opcional)',
  device_nodes_no_sensors_available: 'No hay sensores disponibles',
  device_nodes_sensor_optional: 'Dejar vacío para eliminar todos los enlaces del dispositivo',
  device_nodes_delete_warning: '¡Advertencia: Esta acción no se puede deshacer!',
  device_nodes_delete_button: 'Eliminar enlaces',

  /*
   * |======================|
   * | Scheduled Reports   |
   * |======================|
   */
  // Generated Reports Page
  generated_reports_header: 'Informes generados',
  generated_reports_select_company_message:
    'Seleccione una empresa para ver los informes generados',
  generated_reports_default_error: 'Ocurrió un error al obtener los informes generados',
  generated_reports_config_button: 'Configuración',
  generated_reports_config_name_header: 'Nombre de configuración del informe',
  generated_reports_date_header: 'Fecha del informe',
  generated_reports_type_header: 'Tipo de informe',
  generated_reports_file_name_header: 'Nombre del archivo',
  generated_reports_parameters_header: 'Parámetros',

  // Report Configs Page
  report_configs_header: 'Configuraciones de informes',
  report_configs_select_company_message:
    'Seleccione una empresa para gestionar las configuraciones de informes',
  report_configs_default_error: 'Ocurrió un error al obtener las configuraciones de informes',
  report_configs_name_header: 'Nombre del informe',
  report_configs_type_header: 'Tipo de informe',
  report_configs_occurrence_header: 'Frecuencia',
  report_configs_device_groups_header: 'Grupos de dispositivos',
  report_configs_email_list_header: 'Lista de correos',
  report_configs_start_date_header: 'Fecha de inicio',
  report_configs_end_date_header: 'Fecha de finalización',
  report_configs_next_execution_header: 'Próxima ejecución',
  report_configs_actions_header: 'Acciones',
  report_configs_delete_action: 'Eliminar',
  report_configs_delete_success: 'Configuración de informe eliminada correctamente',
  report_configs_delete_error: 'Ocurrió un error al eliminar la configuración de informe',
  report_configs_create_button: 'Crear configuración de informe',
  report_configs_edit_action: 'Editar',

  // Report Config Form
  report_config_form_report_name: 'Nombre del informe',
  report_config_form_report_type: 'Tipo de informe',
  report_config_form_occurrence: 'Frecuencia',
  report_config_form_device_groups: 'Grupos de dispositivos',
  report_config_form_email_list: 'Lista de correos',
  report_config_form_email_list_hint: 'Separe múltiples correos con comas',
  report_config_form_start_date: 'Fecha de inicio',
  report_config_form_end_date: 'Fecha de finalización',
  report_config_form_calculate: 'Calcular',
  report_config_form_calc_min: 'Mínimo',
  report_config_form_calc_max: 'Máximo',
  report_config_form_calc_average: 'Promedio',
  report_config_form_cancel: 'Cancelar',
  report_config_form_create: 'Crear',
  report_config_form_update: 'Actualizar',
  report_config_form_field_required: 'Este campo es obligatorio',
  report_config_form_device_groups_required: 'Debe seleccionarse al menos un grupo de dispositivos',
  report_config_form_license_settings: 'Configuración del informe de licencia',
  report_config_form_license_is_active: 'Está activo',
  report_config_form_license_is_valid: 'Es válido',

  // Report Types
  report_type_consumption: 'Informe de consumo',
  report_type_consumption_export: 'Exportación de consumo',
  report_type_customer_billing: 'Informe de facturación de clientes',
  report_type_alarm: 'Informe de alarmas',
  report_type_transmission: 'Informe de transmisión',
  report_type_license: 'Informe de licencia',

  // Report Occurrence
  report_occurrence_daily: 'Diario',
  report_occurrence_weekly: 'Semanal',
  report_occurrence_monthly: 'Mensual',

  // Create/Edit Pages
  report_config_create_header: 'Crear configuración de informe',
  report_config_create_success: 'Configuración de informe creada correctamente',
  report_config_create_error: 'Ocurrió un error al crear la configuración de informe',
  report_config_edit_header: 'Editar configuración de informe',
  report_config_update_success: 'Configuración de informe actualizada correctamente',
  report_config_update_error: 'Ocurrió un error al actualizar la configuración de informe',
  report_config_fetch_error: 'Ocurrió un error al obtener la configuración de informe',
  report_config_not_found: 'Configuración de informe no encontrada',
  report_config_form_email_list_required:
    'Se requiere al menos una dirección de correo electrónico',
  report_config_form_email_invalid: 'Dirección de correo electrónico inválida: {{email}}',
  report_config_form_email_no_spaces:
    'Las direcciones de correo electrónico no pueden contener espacios',
  report_configs_delete_confirm_title: 'Eliminar configuración de informe',
  report_configs_delete_confirm_message:
    '¿Está seguro de que desea eliminar la configuración de informe "{{reportName}}"? Esta acción no se puede deshacer.',
  report_configs_delete_cancel: 'Cancelar',
  report_configs_delete_confirm: 'Eliminar',
  report_configs_deleting: 'Eliminando...',

  /*
   * |====================|
   * | Sensors Data Page  |
   * |====================|
   */

  // Page
  sensors_data_no_selection_made: 'No se ha realizado ninguna selección',
  sensors_data_no_selection_subtitle:
    'Use los controles de arriba para seleccionar un dispositivo o un grupo de dispositivos para ver sus lecturas de sensores.',

  // Device Readings Selector Generic
  sensors_data_select_device_group: 'Seleccionar grupo de dispositivos',
  sensors_data_search_device_group: 'Buscar por nombre de grupo de dispositivos',
  sensors_data_add: 'Agregar',
  sensors_data_select_device: 'Seleccionar dispositivo',
  sensors_data_search_device: 'Buscar por nombre o número de dispositivo',
  sensors_data_select_sensor: 'Seleccionar sensor',
  sensors_data_search_sensor: 'Buscar por nombre o índice de sensor',
  sensors_data_select_devices: 'Seleccionar dispositivos',
  sensors_data_select_sensor_type: 'Seleccionar tipo de sensor',
  sensors_data_search_sensor_type: 'Buscar por tipo de sensor',
  sensors_data_submit: 'Enviar',

  // Device Readings Selector Specific
  sensors_data_select_sensors: 'Seleccionar sensores',

  // Selected Items Display
  sensors_data_group: 'Grupo',

  // Readings Data Display
  sensors_data_click_to_view_readings: 'Haga clic para ver las lecturas',
  sensors_data_view_sensor_data_subtitle: 'Ver datos del sensor e información de exportación',
  sensors_data_raw: 'Sin procesar',
  sensors_data_export: 'Exportar',
  sensors_data_format: 'Formato',
  sensors_data_csv: 'CSV',
  sensors_data_excel: 'EXCEL',
  sensors_data_device_number: 'Número de dispositivo',
  sensors_data_device_name: 'Nombre del dispositivo',
  sensors_data_sensor_name: 'Nombre del sensor',
  sensors_data_date: 'Fecha',
  sensors_data_value: 'Valor',
  sensors_data_no_data_available: 'No hay datos disponibles',
  sensors_data_sensor_index: 'Índice del sensor',
  sensors_data_counters: 'Contadores',
  sensors_data_previous: 'Anterior',
  sensors_data_delta: 'Delta',
  sensors_data_collapse: 'Contraer',

  // Sensors Data Chart
  sensors_data_chart_no_data_available: 'No hay datos disponibles',
  sensors_data_chart_no_numeric_data_subtitle:
    'La solicitud fue exitosa, pero no se devolvieron datos numéricos para el rango seleccionado.',
  sensors_data_chart_min: 'mín -',
  sensors_data_chart_max: 'máx -',

  // Sensors Data Map
  sensors_data_map_loading: 'Cargando mapa...',

  //Warranty Data
  manufacturing_date: 'Fecha de fabricación',
  warranty_type: 'Tipo de garantía',
  warranty_extended_support: 'Soporte extendido',
  warranty_basic: 'Básica',
  warranty_status: 'Estado de la garantía',
  warranty_status_UNKNOWN: 'Desconocido',
  warranty_status_IN_WARRANTY: 'En garantía',
  warranty_status_EXPIRED: 'Expirada',
  warranty_period_months: 'Período de garantía',
  install_date: 'Fecha de instalación',
  install_warranty_exp_date: 'Fecha de vencimiento de la garantía de instalación',
  install_warranty_period_months: 'Período de garantía de instalación',

  // Mobile Query Preview
  sensors_data_mobile_groups: 'Grupo(s)',
  sensors_data_mobile_sensors: 'Sensor(es)',
  sensors_data_mobile_types: 'Tipo(s)',
  sensors_data_mobile_no_filters_selected: 'No se han seleccionado filtros',

  // Quick Sensor Selector
  sensors_data_quick_select_sensor: 'Seleccione un sensor para ver las lecturas',

  // Mobile Fab Button
  sensors_data_view_table: 'ver tabla',
  sensors_data_view_chart: 'ver gráfico',
  // Fallbacks added to keep locale keys aligned with English.
  confirm_registration_welcome_to_thingslog: 'Welcome to Thingslog!',
  confirm_registration_completed: 'REGISTRATION COMPLETED',
  confirm_registration_failed: 'REGISTRATION FAILED',
  confirm_registration_completed_description:
    'Your registration process is completed. You can login now. If you face issue, contact our support at {{email}}',
  confirm_registration_failed_description:
    'We encountered a problem with registration. If you face issues logging in, please, contact our support at {{email}}',
  confirm_registration_visit_website: 'Visit Our Website',
  confirm_registration_visit_ecommerce: 'Visit Our Online Store',
  device_counter_statistics_must_have_initialized_params:
    'Parameters Q3, R, and Diameter are required on pulse input connected to a water meter sensor.',
  transmissions_page_yes: 'Yes',
  transmissions_page_no: 'No',
  device_groups_add_sensor_device: 'Add sensor and device to group',
  value_range_name_incorrect_time: 'Incorrect time format',
  value_range_error_occurred: 'An error occurred',
  // Dashboard localization additions
  cancel: 'Cancelar',
  edit: 'Editar',
  save_btn: 'Guardar',
  resize: 'Cambiar tamaño',
  value: 'Valor',
  time: 'Hora',
  dashboards_title: 'Paneles',
  dashboard_add_dashboard: 'Añadir Panel',
  dashboard_edit_dashboard: 'Editar Panel',
  dashboard_delete_dashboard: 'Eliminar Panel',
  dashboard_search_dashboards: 'Buscar paneles',
  dashboard_search_by_name: 'buscar por nombre',
  dashboard_create_dashboard: 'Crear Panel',
  dashboard_save_dashboard: 'Guardar Panel',
  dashboard_name: 'Panel Nombre',
  dashboard_name_required: 'Panel Nombre es obligatorio',
  dashboard_name_max_length: 'Panel Nombre debe tener menos de 100 caracteres',
  dashboard_time_period: 'Periodoo',
  dashboard_dashboard_time_period: 'Periodoo del panel',
  dashboard_dashboard_time_period_description: 'El período de datos predeterminado del panel.',
  dashboard_save_period: 'Guardar Periodo',
  dashboard_edit_dashboard_period: 'Editar Periodoo del panel',
  dashboard_period: 'Periodoo del panel',
  dashboard_predefined_period: 'Periodoo predefinido',
  dashboard_period_dashboard: 'Panel',
  dashboard_period_predefined: 'Predefinido',
  dashboard_period_preset: 'Preajuste',
  dashboard_period_custom: 'Personalizado',
  dashboard_timespan_today: 'Hoy',
  dashboard_timespan_yesterday: 'Ayer',
  dashboard_timespan_this_week: 'Esta semana',
  dashboard_timespan_this_month: 'Este mes',
  dashboard_timespan_this_year: 'Este año',
  dashboard_timespan_past_1d: 'Último 1 día',
  dashboard_timespan_past_1w: 'Última 1 semana',
  dashboard_timespan_past_1m: 'Último 1 mes',
  dashboard_timespan_past_1y: 'Último 1 año',
  dashboard_start_date_required: 'Iniciar date is required',
  dashboard_end_date_required: 'La fecha final es obligatoria',
  dashboard_end_date_before_start_error: 'fin fecha antes inicio error',
  dashboard_predefined_period_required: 'predefinido periodo obligatorio',
  dashboard_default_dashboard_name: 'Predeterminado Panel',
  dashboard_loading: 'Cargando...',
  dashboard_redirecting: 'Redirigiendo...',
  dashboards_load_error: 'cargar error',
  dashboard_load_error: 'cargar error',
  dashboard_loading_data_sources: 'cargando datos fuentes',
  dashboard_data_sources_load_error: 'datos fuentes cargar error',
  dashboard_empty_title: 'Crea tu primer widget',
  dashboard_empty_description: 'Añade un widget para empezar a visualizar datos en este panel.',
  dashboard_confirm_changes_title: 'Confirmar cambios',
  dashboard_save_layout_confirmation:
    '¿Seguro que quiere guardar los cambios? Todas las modificaciones se aplicarán al panel.',
  dashboard_save_layout: 'Guardar diseño',
  dashboard_edit_layout: 'Editar diseño',
  dashboard_add_widget: 'Añadir widget',
  dashboard_widgets: 'Widgets',
  dashboard_widget: 'Widget',
  dashboard_untitled_widget: 'Widget sin título',
  dashboard_no_widgets_yet: 'no widgets yet',
  dashboard_create_widget: 'Crear widget',
  dashboard_save_widget: 'Guardar widget',
  dashboard_edit_widget: 'Editar widget',
  dashboard_delete_widget: 'Eliminar widget',
  dashboard_yes_delete: 'Sí, eliminar',
  dashboard_widget_no_longer_exists: 'El widget ya no existe.',
  dashboard_widget_delete_confirmation_prefix: 'Esto eliminará permanentemente el widget',
  dashboard_widget_delete_confirmation_suffix: 'Esta acción no se puede deshacer.',
  dashboards_empty_no_dashboards_title: 'No hay paneles',
  dashboards_empty_no_results_title: 'No hay resultados',
  dashboards_empty_no_dashboards_description: 'Todavía no se han creado paneles.',
  dashboards_empty_no_results_description: 'No hay paneles que coincidan con la búsqueda.',
  dashboard_add_default_dashboard: 'Añadir Predeterminado Panel',
  dashboard_this_dashboard: 'este panel',
  dashboard_delete_confirmation: '¿Seguro que quieres eliminar {{name}}?',
  dashboard_no_longer_exists: 'Panel El  ya no existe.',
  dashboard_edit_named_dashboard: 'Editar {{name}}',
  dashboard_fallback_dashboard: 'Panel',
  dashboard_edit_current_dashboard: 'editar actual panel',
  dashboard_all_dashboards: 'All Paneles',
  dashboard_start_selector_guide: 'inicio selector guía',
  dashboard_close_dashboards: 'Cerrar paneles',
  dashboard_open_dashboards: 'Abrir paneles',
  dashboard_edit_period: 'Editar panel periodo',
  dashboard_variables: 'Variables',
  dashboard_hide_app_header: 'Ocultar encabezado de la aplicación',
  dashboard_show_app_header: 'Mostrar encabezado de la aplicación',
  dashboard_start_tour: 'inicio tour',
  dashboard_remove_from_favorites: 'Quitar de favoritos',
  dashboard_add_to_favorites: 'Añadir a favoritos',
  dashboard_default_dashboard: 'Predeterminado panel',
  dashboard_set_as_default: 'Establecer como predeterminado',
  dashboard_favorite_tooltip: 'Marcar como favorito',
  dashboard_default_tooltip: 'Panel predeterminado',
  dashboard_widget_type: 'Tipo de widget',
  dashboard_widget_type_required: 'El tipo de widget es obligatorio',
  dashboard_widget_type_line_chart: 'Gráfico de líneas',
  dashboard_widget_type_bar_chart: 'Gráfico de barras',
  dashboard_widget_type_pie_chart: 'Gráfico circular',
  dashboard_widget_type_area_chart: 'Gráfico de área',
  dashboard_widget_type_gauge: 'Indicador',
  dashboard_widget_type_value: 'Valor',
  dashboard_widget_type_table: 'Tabla',
  dashboard_widget_title: 'Título',
  dashboard_widget_title_required: 'El título es obligatorio',
  dashboard_widget_title_max_length: 'El título debe tener menos de 100 caracteres',
  dashboard_data_source: 'Fuente de datos',
  dashboard_data_source_required: 'La fuente de datos es obligatoria',
  dashboard_query_settings: 'Configuración de consulta',
  dashboard_no_data_sources_available: 'No hay fuentes de datos disponibles',
  dashboard_no_data_sources_description:
    'Configura una fuente de datos del panel antes de crear o editar widgets.',
  dashboard_select_data_source_to_configure_query:
    'Selecciona una fuente de datos para configurar la consulta.',
  dashboard_query_type_not_supported: 'Este tipo de consulta aún no es compatible.',
  dashboard_no_widget_timeframe: 'Sin periodo de widget',
  dashboard_no_widget_timeframe_description: 'Este widget hereda el período del panel.',
  dashboard_widget_time_period: 'Período del widget',
  dashboard_widget_time_period_description:
    'Define un período propio para este widget o usa el período del panel.',
  dashboard_edit_widget_timeframe: 'Editar período del widget',
  dashboard_edit_widget_timeframe_inherited:
    'Editar período del widget. Actualmente se hereda del panel.',
  dashboard_widget_settings: 'Configuración del widget',
  dashboard_shift_scroll_to_zoom: 'Mayús + desplazamiento para acercar',
  dashboard_zoom_in: 'Acercar',
  dashboard_zoom_out: 'Alejar',
  dashboard_zoom_reset: 'Restablecer zoom',
  dashboard_inherited_timeframe_label: 'Panel: {{label}}',
  dashboard_edit_timeframe: 'Editar período',
  dashboard_edit_widget_period: 'Editar período del widget',
  dashboard_edit_named_widget: 'Editar {{name}}',
  dashboard_edit_named_widget_period: 'Editar {{name}} Periodo',
  dashboard_data_type: 'Tipo de datos',
  dashboard_data_type_description:
    'Elige si la consulta debe preferir lecturas o valores de flujo calculados.',
  dashboard_readings: 'Lecturas',
  dashboard_query_time_period_description:
    'Selecciona el rango de tiempo para los datos de la consulta.',
  dashboard_battery_level: 'Nivel de batería',
  dashboard_battery_level_description: 'Limita el widget a un rango porcentual de batería.',
  dashboard_signal_level: 'Nivel de señal',
  dashboard_signal_level_description: 'Limita el widget a un rango porcentual de señal.',
  dashboard_signal_values: 'Valores de señal',
  dashboard_signal_values_description: 'Elige qué valores de señal se mostrarán.',
  dashboard_signal_value_required: 'Selecciona al menos un valor de señal',
  dashboard_transmission_values: 'Valores de transmisiones',
  dashboard_transmission_values_description: 'Elige qué valores de transmisión se mostrarán.',
  dashboard_transmission_value_required: 'Selecciona al menos un valor de transmisión',
  dashboard_days: 'Días',
  dashboard_transmissions: 'Transmisiones',
  dashboard_count: 'Recuento',
  dashboard_unit_days: 'días',
  dashboard_transmitting: 'Transmitiendo',
  devices: 'Dispositivos',
  dashboard_device_sensor: 'Sensor del dispositivo',
  dashboard_device_sensor_description: 'Selecciona el dispositivo y el sensor para este widget.',
  dashboard_device_required: 'El dispositivo es obligatorio',
  dashboard_sensor_required: 'El sensor es obligatorio',
  dashboard_devices_optional_description:
    'Pick dispositivos to include. Leave empty to include all dispositivos.',
  dashboard_no_devices_selected_uses_all:
    'No hay dispositivos seleccionados. El widget usará todos los dispositivos.',
  dashboard_device_groups: 'Grupos de dispositivos',
  dashboard_device_groups_description:
    'Selecciona uno o más grupos de dispositivos para la consulta.',
  dashboard_select_one_device_group_required: 'Selecciona al menos un grupo de dispositivos',
  dashboard_device_groups_optional_description:
    'Fuentes de grupo opcionales para la consulta mixta.',
  dashboard_no_groups_selected: 'No hay grupos seleccionados.',
  dashboard_device_sensors: 'Sensores del dispositivo',
  dashboard_device_sensors_description: 'Añade pares de dispositivo y sensor que se deben leer.',
  dashboard_device_sensors_optional_description:
    'Pares opcionales de números de dispositivo e índices de sensor.',
  dashboard_add_device_sensor_required: 'Añade al menos un sensor de dispositivo',
  dashboard_add_device_sensor: 'Añadir Sensor del dispositivo',
  dashboard_remove_device_sensor: 'Remove dispositivo sensor',
  dashboard_device_sensor_types: 'Tipos de sensor del dispositivo',
  dashboard_device_sensor_types_description:
    'Selecciona dispositivos y el tipo de sensor que se leerá de ellos.',
  dashboard_device_sensor_types_optional_description:
    'Grupos opcionales de dispositivos asociados por tipo de sensor.',
  dashboard_add_device_sensor_type_required: 'Añade al menos un tipo de sensor de dispositivo',
  dashboard_sensor_type: 'Sensor Tipo',
  dashboard_add_sensor_type: 'Añadir Sensor Tipo',
  dashboard_remove_sensor_type: 'Quitar tipo de sensor',
  dashboard_variable: 'variable',
  dashboard_sensor_index_option: 'Sensor {{index}}',
  dashboard_visualization: 'Visualización',
  dashboard_visualization_description: 'Opciones de visualización y estilo del gráfico',
  dashboard_visualization_show_grid: 'Mostrar cuadrícula',
  dashboard_visualization_show_legend: 'Mostrar leyenda',
  dashboard_visualization_render_legend_aside: 'Leyenda a un lado',
  dashboard_visualization_show_legend_aside: 'Leyenda a un lado',
  dashboard_visualization_show_x_axis_labels: 'Mostrar etiquetas del eje X',
  dashboard_visualization_show_y_axis_labels: 'Mostrar etiquetas del eje Y',
  dashboard_visualization_line_thickness: 'Grosor de línea',
  dashboard_visualization_interpolation: 'Interpolación',
  dashboard_visualization_show_points: 'Mostrar puntos',
  dashboard_visualization_points_hidden_helper:
    'Los puntos se ocultan automáticamente cuando la serie temporal tiene más de {{count}} puntos.',
  dashboard_visualization_stack_series: 'Apilar series',
  dashboard_visualization_fill_opacity: 'Opacidad de relleno',
  dashboard_visualization_orientation: 'Orientación',
  dashboard_visualization_grouping: 'Agrupación',
  dashboard_visualization_bar_thickness: 'Grosor de barra',
  dashboard_visualization_shape: 'Forma',
  dashboard_visualization_gauge_type: 'Tipo de indicador',
  dashboard_visualization_bar_orientation: 'Orientación de barra',
  dashboard_visualization_minimum: 'Mínimo',
  dashboard_visualization_maximum: 'Máximo',
  dashboard_visualization_gauge_color: 'Color del indicador',
  dashboard_visualization_value_color: 'Color base',
  dashboard_visualization_value_prefix: 'Prefijo',
  dashboard_visualization_value_suffix: 'Sufijo',
  dashboard_visualization_value_stacked: 'Prefijo arriba, sufijo abajo',
  dashboard_visualization_value_compact: 'Números compactos',
  dashboard_visualization_value_target: 'Objetivo',
  dashboard_visualization_value_show_target_percentage: 'Mostrar % del objetivo',
  dashboard_visualization_value_text_color: 'Color de texto personalizado',
  dashboard_visualization_colors: 'Colores',
  dashboard_value_percent_of_target: '{{percent}}% del objetivo',
  dashboard_value_percent_above_target: '{{percent}}% por encima del objetivo',
  dashboard_visualization_show_value: 'Mostrar valor',
  dashboard_visualization_show_min_max: 'Mostrar mín./máx.',
  dashboard_visualization_show_thresholds: 'Mostrar umbrales',
  dashboard_visualization_paginate_rows: 'Paginar filas',
  dashboard_visualization_thresholds: 'Umbrales',
  dashboard_visualization_add_threshold: 'Añadir umbral',
  dashboard_visualization_level: 'Nivel',
  dashboard_visualization_label: 'Etiqueta',
  dashboard_visualization_color: 'Color',
  dashboard_visualization_remove_threshold: 'Quitar umbral',
  dashboard_visualization_threshold_warning: 'Advertencia',
  dashboard_visualization_threshold_critical: 'Crítico',
  dashboard_visualization_threshold_named: 'Umbral {{index}}',
  dashboard_visualization_option_fine: 'Fino',
  dashboard_visualization_option_standard: 'Estándar',
  dashboard_visualization_option_bold: 'Grueso',
  dashboard_visualization_option_straight: 'Recta',
  dashboard_visualization_option_smooth: 'Suave',
  dashboard_visualization_option_stepped: 'Escalonada',
  dashboard_visualization_option_subtle: 'Sutil',
  dashboard_visualization_option_balanced: 'Equilibrada',
  dashboard_visualization_option_solid: 'Sólida',
  dashboard_visualization_option_vertical: 'Vertical',
  dashboard_visualization_option_horizontal: 'Horizontal',
  dashboard_visualization_option_grouped: 'Agrupada',
  dashboard_visualization_option_stacked: 'Apilada',
  dashboard_visualization_option_slim: 'Delgada',
  dashboard_visualization_option_regular: 'Normal',
  dashboard_visualization_option_wide: 'Ancha',
  dashboard_visualization_option_pie: 'Circular',
  dashboard_visualization_option_donut: 'Dona',
  dashboard_visualization_option_dial: 'Dial',
  dashboard_visualization_option_bar: 'Barra',
  dashboard_add_variable: 'Añadir Variable',
  dashboard_edit_variable: 'Editar Variable',
  dashboard_delete_variable: 'Eliminar Variable',
  dashboard_variable_no_longer_exists: 'La variable ya no existe.',
  dashboard_edit_named_variable: 'Editar {{name}}',
  dashboard_variable_edit_mode_description:
    'Los cambios locales solo afectan a esta vista del panel. Los cambios remotos actualizan la variable guardada.',
  dashboard_local: 'Local',
  dashboard_remote: 'Remota',
  dashboard_variable_name: 'Nombre',
  dashboard_variable_name_required: 'Nombre is required',
  dashboard_variable_name_pattern: 'variable nombre pattern',
  dashboard_variable_label: 'Etiqueta',
  dashboard_variable_label_required: 'Etiqueta is required',
  dashboard_variable_single: 'Única',
  dashboard_variable_multi: 'Múltiple',
  dashboard_variable_value: 'Valor',
  dashboard_variable_values: 'Valores',
  dashboard_variable_value_required: 'Valor is required',
  dashboard_variable_at_least_one_value_required: 'Se requiere al menos un valor',
  dashboard_variable_values_helper: 'Separa varios valores con comas.',
  dashboard_apply_locally: 'Aplicar locally',
  dashboard_no_variables_yet: 'No hay variables',
  dashboard_no_variables_description: 'Aún no hay variables para este panel.',
  dashboard_variable_value_count: '{{count}} valor',
  dashboard_empty_value: 'Vacío',
  dashboard_open_variable_actions: 'Abrir {{name}} actions',
  dashboard_variable_delete_confirmation_prefix: 'Esto eliminará permanentemente la variable',
  dashboard_no_data_available: 'No hay datos disponibles',
  dashboard_widget_failed_to_load_data: 'No se pudieron cargar los datos',
  dashboard_click_to_retry: 'Haz clic para reintentar',
  dashboard_chart_sampled_points_tooltip:
    'Se muestra una muestra de puntos reales. Amplía para ver los puntos omitidos.',
  dashboard_chart_all_points_tooltip: 'Se muestran todos los puntos de datos de la vista actual.',
  dashboard_widget_no_areas: 'Este widget no tiene áreas para mostrar.',
  dashboard_widget_no_bars: 'Este widget no tiene barras para mostrar.',
  dashboard_widget_no_points: 'Este widget no tiene puntos para trazar.',
  dashboard_widget_no_slices: 'Este widget no tiene sectores para mostrar.',
  dashboard_widget_too_many_slices: 'Demasiados sectores para mostrar',
  dashboard_widget_too_many_slices_description:
    'Este widget tiene {{slices}} sectores. Dibujarlos todos hará que el panel tarde en cargarse y responda con lentitud, y el gráfico será difícil de leer.',
  dashboard_widget_render_anyway: 'Mostrar de todos modos',
  dashboard_table_settings_missing: 'Faltan los ajustes de tabla.',
  dashboard_widget_no_rows: 'Este widget no tiene filas para mostrar.',
  dashboard_gauge_settings_missing: 'Faltan los ajustes del indicador.',
  dashboard_value_settings_missing: 'Faltan los ajustes del valor.',
  dashboard_widget_no_value: 'Este widget no tiene valor para mostrar.',
  dashboard_widget_no_numeric_value: 'Este widget no tiene valor numérico para mostrar.',
  dashboard_timestamp: 'Marca de tiempo',
  dashboard_alarm_type: 'Tipo de alarma',
  dashboard_alarm_count: 'Recuento de alarmas',
  dashboard_level: 'Nivel',
  dashboard_series_index: 'Serie {{index}}',
  dashboard_gauge_normal: 'Normal',
  dashboard_gauge_threshold: 'Umbral',
  dashboard_start_named_guide: 'Iniciar {{title}} guía',
  dashboard_expand_named: 'Expandir {{title}}',
  dashboard_expand_named_widget: 'Expandir widget {{title}}',
  dashboard_close_named: 'Cerrar {{title}}',
  dashboard_close_named_widget: 'Cerrar {{title}} widget',
  dashboard_close_expanded_named_widget: 'Cerrar widget {{title}} ampliado',
  dashboard_tour_header_dashboards: 'Ayuda: encabezado paneles.',
  dashboard_tour_header_settings: 'Ayuda: encabezado configuración.',
  dashboard_tour_header_title: 'Ayuda: encabezado título.',
  dashboard_tour_header_period: 'Ayuda: encabezado periodo.',
  dashboard_tour_header_layout: 'Ayuda: encabezado diseño.',
  dashboard_tour_header_add_widget: 'Ayuda: encabezado añadir widget.',
  dashboard_tour_header_variables: 'Ayuda: encabezado variables.',
  dashboard_tour_header_toggle_app_header: 'Ayuda: encabezado alternar aplicación encabezado.',
  dashboard_tour_dashboard_canvas: 'Ayuda: panel área de trabajo.',
  dashboard_tour_selection_search: 'Ayuda: selección búsqueda.',
  dashboard_tour_selection_add: 'Ayuda: selección añadir.',
  dashboard_tour_selection_list: 'Ayuda: selección lista.',
  dashboard_tour_selection_favorite: 'Ayuda: selección favorito.',
  dashboard_tour_selection_default: 'Ayuda: selección predeterminado.',
  dashboard_tour_selection_all: 'Ayuda: selección todos.',
  dashboard_tour_widget_title: 'Ayuda: widget título.',
  dashboard_tour_widget_type: 'Ayuda: widget tipo.',
  dashboard_tour_widget_data_source: 'Ayuda: widget datos fuente.',
  dashboard_tour_query_single_device: 'Ayuda: consulta único dispositivo.',
  dashboard_tour_query_single_sensor: 'Ayuda: consulta único sensor.',
  dashboard_tour_query_specific_devices: 'Ayuda: consulta específicos dispositivos.',
  dashboard_tour_query_battery_range: 'Ayuda: consulta batería rango.',
  dashboard_tour_query_device_groups: 'Ayuda: consulta dispositivo grupos.',
  dashboard_tour_query_device_sensor_list: 'Ayuda: consulta dispositivo sensor lista.',
  dashboard_tour_query_device_sensor_device: 'Ayuda: consulta dispositivo sensor dispositivo.',
  dashboard_tour_query_device_sensor_sensor: 'Ayuda: consulta dispositivo sensor sensor.',
  dashboard_tour_query_device_sensor_add: 'Ayuda: consulta dispositivo sensor añadir.',
  dashboard_tour_query_device_type_list: 'Ayuda: consulta dispositivo tipo lista.',
  dashboard_tour_query_device_type_devices: 'Ayuda: consulta dispositivo tipo dispositivos.',
  dashboard_tour_query_device_type_sensor_type: 'Ayuda: consulta dispositivo tipo sensor tipo.',
  dashboard_tour_query_device_type_add: 'Ayuda: consulta dispositivo tipo añadir.',
  dashboard_tour_query_prefer_flow: 'Ayuda: consulta preferencia flujo.',
  dashboard_tour_query_timespan_mode: 'Ayuda: consulta intervalo modo.',
  dashboard_tour_query_timespan_preset: 'Ayuda: consulta intervalo preajuste.',
  dashboard_tour_query_timespan_custom: 'Ayuda: consulta intervalo personalizado.',
  dashboard_tour_widget_actions: 'Ayuda: widget acciones.',
  dashboard_tour_widget_delete: 'Ayuda: widget eliminar.',
  dashboard_tour_dashboard_name: 'Ayuda: panel nombre.',
  dashboard_tour_dashboard_period: 'Ayuda: panel periodo.',
  dashboard_tour_dashboard_timespan_mode: 'Ayuda: panel intervalo modo.',
  dashboard_tour_dashboard_timespan_preset: 'Ayuda: panel intervalo preajuste.',
  dashboard_tour_dashboard_timespan_custom: 'Ayuda: panel intervalo personalizado.',
  dashboard_tour_variable_add: 'Ayuda: variable añadir.',
  dashboard_tour_variable_row: 'Ayuda: variable fila.',
  dashboard_tour_variable_actions: 'Ayuda: variable acciones.',
  dashboard_tour_variable_name_label: 'Ayuda: variable nombre etiqueta.',
  dashboard_tour_variable_type: 'Ayuda: variable tipo.',
  dashboard_tour_variable_source: 'Ayuda: variable fuente.',
  dashboard_tour_variable_value: 'Ayuda: variable valor.',
  dashboard_tour_variable_actions_form: 'Ayuda: variable acciones formulario.',
  dashboard_dialog_currently_open: 'El diálogo está abierto.',
};

export default i18n_es;
